var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 336,
    viewBox: "0 0 314 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9749 313.641C26.8235 313.641 23.6759 312.437 21.2719 310.032C16.464 305.219 16.464 297.414 21.2719 292.601L274.868 38.6472C279.674 33.8344 287.468 33.8344 292.274 38.6472C297.082 43.46 297.082 51.2647 292.274 56.0775L38.6778 310.032C36.2757 312.437 33.1244 313.641 29.9749 313.641Z",
    fill: "#27E6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283.571 313.641C280.421 313.641 277.272 312.437 274.868 310.032L21.2719 56.0775C16.464 51.2647 16.464 43.46 21.2719 38.6472C26.078 33.8344 33.8717 33.8344 38.6778 38.6472L292.276 292.601C297.084 297.414 297.084 305.219 292.276 310.032C289.872 312.439 286.722 313.641 283.573 313.641H283.571Z",
    fill: "#27E6D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.767 238.987C199.904 215.088 180.185 195.711 156.705 195.84C130.193 195.886 110.372 219.599 114.271 245.345C114.271 245.345 114.273 245.356 114.276 245.371C114.887 249.424 116.058 253.274 117.697 256.85L117.691 256.856C117.691 256.856 117.755 257.003 117.889 257.26C119.819 261.355 122.37 265.081 125.412 268.328L125.403 268.337C125.403 268.337 125.449 268.381 125.534 268.457C128.531 271.629 132 274.337 135.817 276.477L135.804 276.489C135.804 276.489 135.85 276.509 135.935 276.542C139.118 278.312 142.538 279.689 146.128 280.607L146.113 280.621C146.193 280.638 146.273 280.647 146.353 280.661C150.806 281.785 155.945 282.224 160.871 281.739L160.851 281.761C160.988 281.745 161.122 281.719 161.259 281.701C183.185 279.41 199.729 260.871 199.767 239.007C199.767 238.997 199.767 238.988 199.767 238.981V238.987Z",
    fill: "#141332"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.99 315.688V315.63C178.083 314.575 178.12 313.029 177.958 311.534V311.521C177.958 311.521 177.956 311.516 177.954 311.512C177.918 311.175 177.876 310.84 177.825 310.507C177.694 309.655 177.507 308.823 177.279 308.009C177.285 308.022 177.29 308.032 177.296 308.045L177.27 307.974C176.95 306.838 176.541 305.74 176.047 304.689L176.032 304.651C176.032 304.651 176.028 304.647 176.027 304.647C175.594 303.735 175.097 302.859 174.545 302.021C174.545 302.021 174.548 302.021 174.55 302.021L174.521 301.983C174.008 301.209 173.443 300.475 172.835 299.776L172.781 299.705L172.777 299.709C172.104 298.942 171.379 298.225 170.604 297.562C170.604 297.558 170.602 297.555 170.6 297.551L170.546 297.511C169.777 296.857 168.962 296.258 168.106 295.719L168.046 295.675C168.046 295.675 168.056 295.686 168.064 295.692C167.171 295.131 166.234 294.636 165.258 294.211C165.251 294.208 165.245 294.202 165.238 294.199L165.205 294.188C164.296 293.794 163.352 293.465 162.381 293.201L162.376 293.193C162.376 293.193 162.341 293.184 162.276 293.17C162.083 293.119 161.888 293.071 161.692 293.026L161.625 293.004C161.645 293.009 161.663 293.019 161.683 293.024C160.334 292.705 158.935 292.514 157.499 292.467C157.484 292.465 157.47 292.461 157.455 292.46L157.391 292.465C156.826 292.445 156.139 292.441 155.166 292.516L155.16 292.509C155.16 292.509 155.12 292.514 155.058 292.523C154.335 292.582 153.622 292.674 152.92 292.804L152.86 292.809C152.873 292.809 152.884 292.809 152.895 292.809C151.676 293.033 150.492 293.359 149.356 293.782C149.356 293.782 149.272 293.809 149.125 293.873C148.509 294.109 147.907 294.373 147.321 294.667C147.276 294.685 147.252 294.696 147.252 294.696L147.23 294.712C145.866 295.399 144.586 296.225 143.41 297.176V297.172C143.41 297.172 143.392 297.185 143.372 297.205C142.34 298.043 141.389 298.977 140.531 299.989C140.491 300.031 140.466 300.06 140.466 300.06L140.48 300.048C139.953 300.676 139.46 301.335 139.005 302.021V302.018C139.005 302.018 138.996 302.029 138.987 302.049C138.194 303.252 137.522 304.542 136.983 305.9C136.973 305.922 136.962 305.942 136.951 305.964L136.94 306.009C136.816 306.326 136.7 306.647 136.591 306.971L136.585 306.965C136.578 306.989 136.574 307.015 136.567 307.038C136.125 308.369 135.811 309.757 135.638 311.188C135.634 311.212 135.627 311.234 135.623 311.256L135.634 311.21C135.563 311.88 135.443 313.073 135.487 314.222L135.48 314.215C135.481 314.262 135.487 314.308 135.49 314.355C135.534 315.968 135.751 317.538 136.132 319.042V319.055C136.132 319.055 136.134 319.053 136.134 319.051C136.471 320.375 136.932 321.648 137.503 322.861C137.503 322.866 137.505 322.872 137.507 322.877L137.523 322.906C138 323.913 138.553 324.876 139.176 325.789L139.191 325.814C139.191 325.814 139.191 325.809 139.191 325.807C139.762 326.643 140.391 327.437 141.073 328.18L141.097 328.202C141.831 329.003 142.628 329.744 143.477 330.425L143.526 330.47C143.526 330.47 143.533 330.47 143.537 330.47C144.459 331.204 145.441 331.865 146.479 332.441C146.476 332.441 146.474 332.441 146.47 332.441L146.497 332.453C147.639 333.085 148.847 333.613 150.107 334.029L150.161 334.052C150.161 334.052 150.171 334.052 150.176 334.052C151.398 334.451 152.669 334.741 153.976 334.914C153.964 334.914 153.953 334.914 153.94 334.914H153.998C154.349 334.961 154.702 334.997 155.057 335.027C155.093 335.03 155.128 335.037 155.164 335.041L155.157 335.034C156.211 335.112 157.308 335.139 158.879 334.997H158.893C158.893 334.997 158.899 334.997 158.901 334.997C159.674 334.921 160.434 334.803 161.179 334.644C161.188 334.644 161.197 334.642 161.205 334.64H161.203C162.312 334.404 163.387 334.08 164.425 333.681C164.416 333.686 164.409 333.692 164.401 333.695L164.432 333.679C165.383 333.313 166.302 332.88 167.18 332.386C167.233 332.361 167.262 332.346 167.262 332.346L167.258 332.342C168.235 331.789 169.162 331.161 170.035 330.465L170.064 330.449C170.064 330.449 170.075 330.436 170.08 330.43C170.642 329.981 171.181 329.504 171.693 328.999C171.699 328.994 171.706 328.99 171.711 328.986H171.71C172.693 328.014 173.584 326.951 174.368 325.807C174.366 325.811 174.365 325.814 174.363 325.82L174.37 325.805C174.792 325.188 175.183 324.549 175.539 323.886C175.539 323.884 175.543 323.882 175.545 323.88C176.152 322.751 176.658 321.56 177.056 320.322L177.069 320.299C177.069 320.299 177.069 320.288 177.069 320.282C177.238 319.754 177.383 319.217 177.51 318.672C177.514 318.661 177.52 318.651 177.525 318.64L177.52 318.634C177.745 317.667 177.905 316.675 177.992 315.662C177.992 315.671 177.994 315.682 177.996 315.691L177.99 315.688Z",
    fill: "#141332"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.742 282.114C134.383 282.114 115.413 264.777 113.729 242.093C112.874 230.579 116.548 219.422 124.074 210.676C131.6 201.93 142.076 196.642 153.572 195.786C165.066 194.932 176.212 198.61 184.945 206.145C193.679 213.682 198.96 224.173 199.813 235.685C201.577 259.452 183.702 280.224 159.969 281.99C158.887 282.071 157.809 282.111 156.742 282.111V282.114ZM156.838 196.01C155.762 196.01 154.683 196.05 153.6 196.13C142.194 196.979 131.8 202.225 124.334 210.9C116.868 219.577 113.223 230.645 114.071 242.068C115.82 265.645 136.394 283.398 159.944 281.652C183.489 279.9 201.222 259.292 199.473 235.714C198.625 224.293 193.386 213.884 184.724 206.408C176.883 199.643 167.083 196.01 156.84 196.01H156.838Z",
    fill: "url(#paint0_linear_376_4207)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 281.297C149.489 281.297 147.753 281.129 146.076 280.792C145.984 280.774 145.924 280.683 145.942 280.59C145.96 280.497 146.045 280.436 146.144 280.456C149.531 281.133 153.17 281.118 157.596 280.406C167.946 278.746 174.771 274.281 181.832 268.091C191.991 259.185 198.434 246.016 198.647 233.722C198.692 231.044 198.299 229.022 198.01 227.547C197.965 227.318 197.923 227.099 197.885 226.895C197.868 226.803 197.928 226.711 198.021 226.695C198.117 226.675 198.205 226.739 198.221 226.832C198.259 227.036 198.301 227.252 198.345 227.48C198.636 228.969 199.034 231.013 198.987 233.726C198.774 246.114 192.286 259.38 182.055 268.35C174.949 274.579 168.079 279.072 157.649 280.747C155.367 281.113 153.29 281.297 151.348 281.297H151.35Z",
    fill: "url(#paint1_linear_376_4207)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.848 281.936C160.762 281.936 160.688 281.872 160.677 281.785C160.666 281.69 160.733 281.606 160.826 281.593C171.875 280.275 180.934 273.146 185.351 269.012C194.012 260.907 199.204 249.959 199.593 238.977C199.596 238.883 199.687 238.812 199.771 238.812C199.866 238.815 199.94 238.895 199.937 238.99C199.544 250.063 194.314 261.097 185.587 269.264C181.14 273.426 172.015 280.605 160.868 281.936C160.861 281.936 160.855 281.936 160.848 281.936Z",
    fill: "url(#paint2_linear_376_4207)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.459 278.627C140.412 278.627 135.784 276.672 135.733 276.65C135.646 276.611 135.606 276.511 135.644 276.424C135.683 276.337 135.783 276.296 135.87 276.335C135.926 276.36 141.7 278.791 150.163 278.187C157.974 277.628 169.747 274.293 181.468 261.574C193.759 248.237 196.074 236.31 195.852 228.653C195.61 220.358 192.424 215.145 192.392 215.092C192.341 215.012 192.366 214.906 192.446 214.855C192.526 214.806 192.632 214.83 192.683 214.91C192.715 214.963 195.947 220.24 196.194 228.622C196.423 236.348 194.099 248.376 181.721 261.807C169.916 274.616 158.047 277.972 150.17 278.531C149.233 278.596 148.33 278.627 147.462 278.627H147.459Z",
    fill: "url(#paint3_linear_376_4207)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.278 274.248C139.513 274.248 137.136 273.891 135.176 273.401C128.782 271.806 125.314 268.495 125.28 268.462C125.211 268.397 125.211 268.288 125.276 268.22C125.342 268.151 125.451 268.151 125.518 268.217C125.553 268.249 128.966 271.505 135.279 273.075C141.109 274.526 150.67 274.79 163.132 267.831C177.63 259.736 188.544 244.852 190.939 229.914C192.438 220.567 190.377 212.522 184.984 206.652C184.92 206.582 184.924 206.473 184.995 206.409C185.064 206.346 185.173 206.351 185.237 206.42C190.705 212.371 192.794 220.515 191.277 229.969C188.866 245.008 177.885 259.988 163.299 268.133C154.915 272.815 147.821 274.25 142.28 274.25L142.278 274.248Z",
    fill: "url(#paint4_linear_376_4207)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.755 268.32C131.811 268.32 127.538 266.605 124.652 264.746C119.522 261.441 117.547 256.968 117.527 256.925C117.489 256.837 117.529 256.737 117.616 256.699C117.704 256.663 117.804 256.701 117.842 256.788C117.86 256.832 119.804 261.22 124.854 264.467C129.516 267.465 137.859 270.076 151.133 265.492C168.03 259.66 183.303 240.798 185.178 223.446C185.965 216.166 184.694 206.142 174.178 199.721C174.096 199.672 174.071 199.566 174.12 199.484C174.171 199.402 174.276 199.377 174.356 199.428C185.027 205.943 186.316 216.104 185.519 223.483C183.632 240.953 168.255 259.944 151.246 265.817C146.022 267.619 141.548 268.319 137.757 268.319L137.755 268.32Z",
    fill: "url(#paint5_linear_376_4207)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.297 261.259C130.218 261.259 126.621 260.359 123.532 258.556C115.849 254.078 114.112 245.463 114.098 245.378C114.08 245.285 114.142 245.194 114.234 245.178C114.325 245.159 114.418 245.221 114.434 245.314C114.451 245.398 116.162 253.865 123.708 258.263C129.576 261.683 137.332 261.798 146.757 258.604C165.781 252.161 178.373 231.604 178.199 216.446C178.086 206.562 172.824 199.491 163.384 196.534C163.293 196.505 163.242 196.41 163.271 196.319C163.299 196.228 163.397 196.179 163.486 196.206C173.08 199.211 178.426 206.398 178.541 216.443C178.715 231.721 166.03 252.44 146.866 258.93C142.28 260.483 138.081 261.259 134.297 261.259Z",
    fill: "url(#paint6_linear_376_4207)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.817 253.4C130.761 253.4 128.78 253.136 126.906 252.602C111.453 248.203 114.362 230.845 114.393 230.67C114.409 230.577 114.497 230.514 114.591 230.532C114.684 230.548 114.746 230.637 114.73 230.73C114.699 230.902 111.845 247.959 126.998 252.272C133.326 254.073 140.936 252.746 148.419 248.53C158.335 242.944 166.18 233.354 168.889 223.507C171.288 214.791 170.197 207.289 165.816 202.381C161.676 197.742 155.016 195.879 147.074 197.137C146.975 197.154 146.892 197.088 146.877 196.995C146.863 196.902 146.926 196.813 147.019 196.798C155.082 195.524 161.85 197.423 166.071 202.152C170.531 207.149 171.648 214.764 169.218 223.596C166.485 233.529 158.579 243.197 148.585 248.827C143.23 251.844 137.803 253.398 132.814 253.398L132.817 253.4Z",
    fill: "url(#paint7_linear_376_4207)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.602 244.883C131.369 244.883 131.138 244.879 130.907 244.87C126.538 244.71 122.814 243.064 120.139 240.108C113.358 232.615 116.557 217.907 127.122 207.988C133.741 201.775 141.045 198.517 147.713 198.821C152.088 199.02 155.849 200.752 158.587 203.831C165.194 211.258 162.048 225.866 151.721 235.727C145.68 241.496 138.212 244.881 131.6 244.881L131.602 244.883ZM127.358 208.241C116.926 218.032 113.736 232.522 120.395 239.879C123.006 242.763 126.647 244.371 130.922 244.528C137.597 244.764 145.298 241.39 151.486 235.481C161.686 225.742 164.821 211.355 158.335 204.06C155.658 201.05 151.981 199.358 147.702 199.165C141.134 198.87 133.911 202.092 127.36 208.241H127.358Z",
    fill: "url(#paint8_linear_376_4207)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.41 236.151C131.242 236.151 131.077 236.148 130.91 236.142C127.751 236.027 125.058 234.835 123.121 232.697C118.23 227.292 120.51 216.707 128.102 209.582C132.848 205.127 138.092 202.791 142.884 203.01C146.046 203.152 148.765 204.406 150.747 206.633C155.511 211.991 153.269 222.503 145.85 229.589C141.518 233.724 136.159 236.151 131.408 236.151H131.41ZM128.22 209.707L128.337 209.833C120.879 216.833 118.608 227.198 123.376 232.466C125.249 234.534 127.858 235.687 130.922 235.8C135.714 235.978 141.196 233.56 145.613 229.341C152.903 222.379 155.136 212.085 150.492 206.861C148.572 204.703 145.937 203.489 142.869 203.35C138.18 203.132 133.014 205.439 128.337 209.831L128.22 209.705V209.707Z",
    fill: "url(#paint9_linear_376_4207)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132.308 227.336C132.214 227.336 132.121 227.334 132.028 227.33C130.259 227.267 128.749 226.598 127.664 225.4C124.925 222.374 126.202 216.447 130.453 212.457C133.112 209.962 136.052 208.658 138.734 208.775C140.506 208.855 142.029 209.558 143.139 210.805C145.808 213.804 144.552 219.691 140.396 223.659C137.971 225.976 134.968 227.336 132.306 227.336H132.308ZM130.688 212.706C126.571 216.57 125.302 222.279 127.918 225.169C128.94 226.298 130.366 226.926 132.041 226.988C134.685 227.066 137.714 225.746 140.16 223.412C144.186 219.568 145.433 213.901 142.884 211.035C141.837 209.856 140.396 209.194 138.72 209.119C136.121 208.995 133.277 210.277 130.688 212.708V212.706Z",
    fill: "url(#paint10_linear_376_4207)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.8 335.279C148.366 335.279 140.349 330.272 136.93 321.995C132.406 311.039 137.627 298.439 148.567 293.909C153.867 291.715 159.702 291.718 165 293.918C170.297 296.119 174.421 300.253 176.614 305.561C178.805 310.869 178.801 316.713 176.605 322.017C174.406 327.322 170.278 331.452 164.978 333.646C162.303 334.753 159.53 335.278 156.8 335.278V335.279ZM137.249 321.864C139.405 327.087 143.464 331.157 148.676 333.322C153.889 335.487 159.633 335.491 164.847 333.331C170.062 331.171 174.124 327.107 176.288 321.888C178.45 316.667 178.454 310.917 176.297 305.694C174.141 300.472 170.082 296.402 164.87 294.237C159.657 292.071 153.914 292.068 148.699 294.227C137.934 298.685 132.797 311.082 137.249 321.864Z",
    fill: "url(#paint11_linear_376_4207)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.03 312.514C177.945 312.514 177.87 312.45 177.859 312.363C177.654 310.671 177.087 308.968 176.072 307.002C173.697 302.398 170.553 299.884 166.562 297.522C160.823 294.126 153.662 293.131 147.874 294.931C146.619 295.32 145.735 295.816 145.09 296.178L144.801 296.34C144.719 296.384 144.613 296.355 144.568 296.271C144.522 296.187 144.553 296.083 144.637 296.038L144.924 295.877C145.583 295.508 146.484 295.002 147.774 294.601C153.653 292.776 160.917 293.782 166.738 297.227C170.78 299.618 173.964 302.169 176.377 306.843C177.412 308.848 177.992 310.589 178.201 312.321C178.212 312.415 178.145 312.501 178.052 312.512C178.045 312.512 178.038 312.512 178.032 312.512L178.03 312.514Z",
    fill: "url(#paint12_linear_376_4207)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.283 305.39C176.219 305.39 176.156 305.354 176.129 305.292C173.808 300.311 169.071 297.157 166.455 295.723C161.325 292.907 155.399 292.159 150.2 293.67C150.112 293.696 150.014 293.645 149.987 293.554C149.962 293.463 150.012 293.368 150.103 293.341C155.39 291.806 161.408 292.563 166.618 295.422C169.271 296.877 174.077 300.078 176.438 305.148C176.478 305.233 176.439 305.335 176.354 305.375C176.33 305.386 176.307 305.392 176.281 305.392L176.283 305.39Z",
    fill: "url(#paint13_linear_376_4207)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.685 318.013C177.685 318.013 177.674 318.013 177.671 318.013C177.576 318.006 177.507 317.922 177.514 317.827C177.525 317.705 178.416 305.483 163.565 298.711C147.994 291.611 140.208 300.646 140.131 300.739C140.07 300.812 139.962 300.821 139.889 300.761C139.817 300.701 139.808 300.593 139.868 300.519C139.946 300.424 147.894 291.183 163.707 298.397C178.787 305.275 177.867 317.732 177.856 317.856C177.849 317.945 177.773 318.013 177.685 318.013Z",
    fill: "url(#paint14_linear_376_4207)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M175.465 324.177C175.439 324.177 175.414 324.171 175.39 324.159C175.305 324.119 175.27 324.015 175.312 323.929C175.352 323.845 179.22 315.489 169.324 306.364C163.292 300.803 154.635 297.973 147.268 299.155C142.669 299.892 139.231 302.094 137.32 305.521C137.274 305.603 137.171 305.634 137.087 305.587C137.005 305.541 136.976 305.435 137.021 305.354C138.985 301.832 142.509 299.57 147.215 298.816C154.684 297.624 163.45 300.484 169.557 306.113C179.649 315.418 175.663 323.995 175.621 324.08C175.592 324.142 175.53 324.177 175.466 324.177H175.465Z",
    fill: "url(#paint15_linear_376_4207)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.262 329.591C171.215 329.591 171.167 329.571 171.135 329.532C171.071 329.461 171.078 329.354 171.149 329.29C171.22 329.227 178.072 322.908 170.073 312.37C164.732 305.334 153.541 301.072 145.126 302.87C141.607 303.622 137.125 305.758 135.745 311.663C135.725 311.754 135.63 311.816 135.539 311.791C135.446 311.769 135.39 311.676 135.412 311.585C136.832 305.503 141.438 303.305 145.055 302.533C153.592 300.712 164.934 305.029 170.345 312.16C178.543 322.961 171.449 329.481 171.376 329.545C171.344 329.574 171.304 329.589 171.262 329.589V329.591Z",
    fill: "url(#paint16_linear_376_4207)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M166.384 332.987C166.324 332.987 166.266 332.956 166.235 332.899C166.189 332.815 166.218 332.712 166.3 332.666C166.338 332.646 170.019 330.545 170.908 326.346C171.599 323.077 170.457 319.428 167.513 315.502C161.561 307.564 149.993 304.824 142.928 307.244C138.338 308.815 135.851 312.361 135.924 317.226C135.924 317.321 135.849 317.399 135.754 317.401H135.753C135.658 317.401 135.582 317.326 135.582 317.232C135.507 312.204 138.078 308.542 142.819 306.918C150 304.459 161.749 307.238 167.789 315.294C170.797 319.304 171.959 323.048 171.244 326.42C170.322 330.772 166.507 332.945 166.471 332.967C166.444 332.981 166.415 332.988 166.387 332.988L166.384 332.987Z",
    fill: "url(#paint17_linear_376_4207)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M159.453 335.115C159.37 335.115 159.295 335.053 159.284 334.968C159.272 334.873 159.335 334.788 159.43 334.775C159.513 334.762 167.896 333.475 167.578 325.745C167.445 322.505 165.652 319.147 162.53 316.29C158.386 312.497 152.687 310.294 147.663 310.541C143.226 310.76 139.895 312.421 138.282 315.218C136.758 317.862 136.914 321.258 138.724 324.78C138.767 324.863 138.734 324.967 138.649 325.011C138.565 325.053 138.462 325.022 138.418 324.936C136.554 321.307 136.401 317.792 137.985 315.045C139.658 312.142 143.09 310.421 147.646 310.195C152.771 309.948 158.553 312.182 162.763 316.033C165.954 318.952 167.785 322.396 167.924 325.728C168.253 333.77 159.568 335.099 159.481 335.112C159.473 335.112 159.464 335.114 159.457 335.114L159.453 335.115Z",
    fill: "url(#paint18_linear_376_4207)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.94 334.781C152.328 334.781 149.461 334.076 146.793 332.617C142.827 330.448 140.15 327.488 139.254 324.279C138.663 322.163 138.898 320.1 139.932 318.312C142.422 314.007 149.828 313.213 156.102 316.574C159.897 318.608 162.724 321.766 163.664 325.022C164.274 327.129 164.074 329.163 163.088 330.9C161.644 333.446 158.533 334.781 154.941 334.781H154.94ZM148.07 314.828C144.609 314.828 141.616 316.085 140.229 318.485C139.241 320.191 139.018 322.163 139.583 324.188C140.454 327.305 143.073 330.192 146.959 332.317C153.134 335.696 160.388 334.97 162.79 330.733C163.73 329.075 163.919 327.134 163.335 325.118C162.421 321.95 159.657 318.871 155.94 316.879C153.361 315.498 150.59 314.828 148.07 314.828Z",
    fill: "url(#paint19_linear_376_4207)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.238 333.46C151.361 333.46 149.303 332.954 147.39 331.909C144.541 330.35 142.617 328.22 141.969 325.907C141.54 324.372 141.711 322.873 142.464 321.573C144.264 318.457 149.605 317.871 154.125 320.291C156.851 321.752 158.884 324.024 159.562 326.37C160.004 327.899 159.859 329.376 159.142 330.64C158.093 332.488 155.838 333.459 153.238 333.459V333.46ZM147.554 331.607C151.958 334.016 157.129 333.495 158.842 330.472C159.513 329.29 159.648 327.905 159.232 326.466C158.579 324.208 156.609 322.014 153.962 320.595C149.601 318.259 144.47 318.785 142.758 321.744C142.053 322.962 141.895 324.368 142.297 325.812C142.919 328.034 144.784 330.092 147.552 331.605L147.554 331.607Z",
    fill: "url(#paint20_linear_376_4207)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.669 331.23C150.612 331.23 149.454 330.946 148.377 330.357C146.772 329.48 145.688 328.278 145.322 326.972C145.079 326.102 145.177 325.251 145.604 324.516C146.622 322.753 149.637 322.42 152.185 323.784C153.721 324.607 154.867 325.889 155.249 327.213C155.5 328.079 155.416 328.917 155.011 329.634C154.416 330.682 153.141 331.231 151.67 331.231L151.669 331.23ZM148.543 330.055C150.956 331.375 153.782 331.104 154.711 329.463C155.071 328.828 155.143 328.083 154.92 327.307C154.563 326.071 153.48 324.865 152.023 324.086C149.634 322.804 146.828 323.081 145.901 324.687C145.52 325.342 145.435 326.1 145.653 326.879C145.993 328.096 147.019 329.223 148.543 330.055Z",
    fill: "url(#paint21_linear_376_4207)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.263 328.214C150.099 328.214 149.926 328.172 149.766 328.085C149.255 327.804 149.182 327.38 149.339 327.083C149.404 326.957 149.526 326.861 149.683 326.814C149.913 326.742 150.195 326.777 150.439 326.908C150.69 327.043 150.874 327.256 150.932 327.482C150.974 327.642 150.952 327.795 150.868 327.924C150.746 328.114 150.517 328.216 150.264 328.216L150.263 328.214ZM149.932 327.119C149.879 327.119 149.828 327.127 149.783 327.139C149.713 327.161 149.664 327.196 149.641 327.241C149.546 327.424 149.659 327.635 149.93 327.782C150.199 327.93 150.488 327.877 150.577 327.737C150.608 327.688 150.615 327.631 150.597 327.566C150.563 327.433 150.439 327.296 150.275 327.209C150.166 327.15 150.043 327.119 149.932 327.119Z",
    fill: "url(#paint22_linear_376_4207)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.056 327.666 150.009 327.646 149.976 327.609C149.92 327.546 149.918 327.451 149.972 327.385C150.043 327.302 157.077 318.787 162.034 310.268C167.042 301.662 169.153 296.877 168.309 296.047C168.242 295.979 168.24 295.872 168.307 295.804C168.377 295.737 168.484 295.735 168.549 295.803C169.231 296.474 169.14 298.743 162.33 310.443C158.337 317.306 153 324.164 151.02 326.641C153.051 325.153 157.828 321.396 162.376 315.928C168.207 308.914 173.128 300.683 170.975 298.104C170.913 298.031 170.924 297.924 170.997 297.862C171.068 297.8 171.177 297.811 171.239 297.884C173.677 300.801 168.131 309.545 162.641 316.146C156.653 323.347 150.265 327.598 150.202 327.64C150.172 327.659 150.14 327.668 150.107 327.668L150.103 327.666Z",
    fill: "url(#paint23_linear_376_4207)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.086 327.666 150.07 327.664 150.054 327.659C149.972 327.635 149.921 327.555 149.934 327.469C149.946 327.38 151.257 318.523 153.669 311.121C156.256 303.172 159.909 293.596 162.619 293.108C162.708 293.089 162.801 293.153 162.817 293.246C162.833 293.339 162.772 293.428 162.679 293.445C160.695 293.803 157.611 300.117 153.994 311.226C152.127 316.964 150.921 323.582 150.472 326.28C152.132 322.653 157.251 311.474 158.673 308.446L158.837 308.096C160.695 304.139 164.565 295.906 165.648 294.355C165.703 294.277 165.81 294.258 165.887 294.313C165.965 294.368 165.983 294.475 165.928 294.552C164.861 296.078 160.855 304.602 159.146 308.242L158.982 308.591C157.285 312.202 150.328 327.413 150.259 327.566C150.23 327.628 150.168 327.666 150.103 327.666Z",
    fill: "url(#paint24_linear_376_4207)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.034 327.666 149.969 327.622 149.943 327.555C149.911 327.471 146.767 319.113 147.483 310.354C148.343 299.827 150.76 294.106 155.086 292.347C155.171 292.31 155.273 292.352 155.31 292.441C155.346 292.529 155.302 292.629 155.215 292.665C151.022 294.37 148.674 300 147.825 310.383C147.283 317.008 148.971 323.405 149.814 326.1C149.623 323.323 149.376 316.875 150.562 310.473C151.996 302.717 154.651 293.288 159.145 292.414C159.241 292.392 159.328 292.458 159.345 292.549C159.363 292.642 159.303 292.733 159.21 292.749C155.851 293.403 152.9 299.718 150.898 310.534C149.345 318.922 150.263 327.389 150.273 327.475C150.283 327.561 150.227 327.641 150.143 327.661C150.131 327.664 150.116 327.666 150.103 327.666Z",
    fill: "url(#paint25_linear_376_4207)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.058 327.666 150.012 327.648 149.98 327.613C149.916 327.546 143.626 320.854 142.081 311.592C140.24 300.562 144.644 296.196 146.623 294.832C146.701 294.779 146.807 294.799 146.861 294.876C146.914 294.954 146.896 295.061 146.817 295.114C144.892 296.442 140.611 300.701 142.419 311.536C143.521 318.133 147.059 323.416 148.972 325.876C147.821 323.72 145.97 319.723 145.132 314.986C144.024 308.733 143.883 296.092 151.265 292.996C151.351 292.958 151.453 293.002 151.489 293.087C151.525 293.175 151.484 293.275 151.398 293.311C144.215 296.321 144.379 308.766 145.47 314.924C146.716 321.963 150.212 327.345 150.249 327.398C150.298 327.473 150.282 327.571 150.212 327.628C150.182 327.653 150.143 327.666 150.105 327.666H150.103Z",
    fill: "url(#paint26_linear_376_4207)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.074 327.666 150.045 327.659 150.019 327.644C149.948 327.604 142.929 323.602 140.094 318.212C137.374 313.036 135.874 309.456 137.97 303.402C138.001 303.312 138.1 303.267 138.189 303.296C138.278 303.327 138.325 303.425 138.294 303.515C136.243 309.438 137.72 312.96 140.398 318.053C142.295 321.664 146.119 324.651 148.385 326.198C146.366 324.294 142.98 320.701 141.398 316.748C139.149 311.126 137.154 304.593 141.987 298.183C142.044 298.106 142.153 298.092 142.227 298.15C142.304 298.206 142.318 298.314 142.26 298.39C137.536 304.658 139.502 311.088 141.716 316.622C144.004 322.34 150.147 327.313 150.208 327.364C150.277 327.42 150.294 327.52 150.243 327.593C150.21 327.642 150.156 327.67 150.101 327.67L150.103 327.666Z",
    fill: "url(#paint27_linear_376_4207)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.094 327.666 150.085 327.666 150.075 327.664C149.954 327.644 137.881 325.501 135.374 315.562C135.35 315.471 135.406 315.376 135.497 315.354C135.588 315.327 135.683 315.385 135.706 315.478C137.536 322.72 144.584 325.738 148.106 326.812C146.448 326.02 144.016 324.691 142.014 322.913C139.154 320.375 135.395 316.21 135.759 309.373C135.765 309.278 135.828 309.21 135.939 309.21C136.034 309.216 136.106 309.296 136.101 309.391C135.745 316.079 139.434 320.165 142.242 322.655C145.575 325.614 150.119 327.316 150.165 327.333C150.248 327.364 150.294 327.453 150.27 327.539C150.25 327.615 150.181 327.666 150.105 327.666H150.103Z",
    fill: "url(#paint28_linear_376_4207)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M147.507 327.835C144.686 327.835 140.289 327.269 137.924 324.073C137.867 323.997 137.884 323.889 137.96 323.833C138.036 323.776 138.144 323.793 138.2 323.869C140.631 327.152 145.306 327.553 148.018 327.489C144.828 327.049 138.845 325.517 136.285 320.209C136.245 320.123 136.28 320.021 136.365 319.98C136.449 319.939 136.552 319.974 136.594 320.06C140.053 327.238 150.003 327.325 150.103 327.325C150.192 327.325 150.267 327.394 150.274 327.484C150.281 327.573 150.22 327.653 150.131 327.668C150.101 327.673 149.034 327.839 147.507 327.839V327.835Z",
    fill: "url(#paint29_linear_376_4207)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.727 329.975C143.249 329.975 142.798 329.906 142.396 329.742C142.309 329.705 142.267 329.605 142.302 329.518C142.336 329.43 142.436 329.387 142.525 329.423C144.226 330.119 147.055 328.92 148.706 328.074C146.431 328.638 142.071 329.323 139.874 327.049C139.809 326.979 139.811 326.872 139.878 326.806C139.947 326.741 140.056 326.743 140.12 326.81C142.96 329.747 149.975 327.356 150.045 327.331C150.128 327.303 150.217 327.34 150.255 327.418C150.294 327.496 150.266 327.591 150.192 327.639C150.015 327.75 146.433 329.973 143.726 329.973L143.727 329.975Z",
    fill: "url(#paint30_linear_376_4207)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M147.352 333.08C147.326 333.08 147.299 333.074 147.274 333.061C147.19 333.018 147.156 332.916 147.199 332.83L149.419 328.462C148.314 329.571 146.314 331.386 144.863 331.615C144.766 331.634 144.681 331.566 144.666 331.473C144.652 331.379 144.715 331.291 144.808 331.277C146.752 330.971 149.943 327.416 149.976 327.382C150.034 327.318 150.13 327.307 150.201 327.354C150.272 327.402 150.296 327.496 150.258 327.573L147.506 332.987C147.476 333.047 147.416 333.081 147.354 333.081L147.352 333.08Z",
    fill: "url(#paint31_linear_376_4207)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M153.267 334.99C153.25 334.99 153.232 334.988 153.216 334.983C151.168 334.34 150.365 330.716 150.077 328.755C149.823 330.623 149.617 333.349 150.301 333.932C150.374 333.994 150.383 334.101 150.321 334.174C150.259 334.247 150.15 334.256 150.079 334.194C148.912 333.198 149.828 328.047 149.935 327.462C149.952 327.376 150.026 327.32 150.114 327.322C150.199 327.327 150.268 327.395 150.275 327.48C150.281 327.544 150.768 333.854 153.319 334.655C153.409 334.682 153.459 334.779 153.43 334.87C153.407 334.943 153.339 334.99 153.267 334.99Z",
    fill: "url(#paint32_linear_376_4207)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M156.425 335.281C156.425 335.281 156.411 335.281 156.403 335.281C152.247 334.735 150.032 327.839 149.939 327.546C149.912 327.462 149.954 327.371 150.034 327.336C150.114 327.3 150.208 327.333 150.252 327.409C150.295 327.487 154.709 335.245 160.202 334.66C160.299 334.649 160.38 334.718 160.391 334.813C160.4 334.908 160.333 334.992 160.238 335.002C155.976 335.45 152.488 331.331 150.886 329.039C151.803 331.131 153.71 334.58 156.449 334.941C156.543 334.953 156.609 335.039 156.596 335.134C156.585 335.219 156.511 335.283 156.425 335.283V335.281Z",
    fill: "url(#paint33_linear_376_4207)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M161.905 334.22C155.402 334.22 150.03 327.677 149.969 327.602C149.912 327.533 149.92 327.431 149.985 327.369C150.05 327.307 150.152 327.307 150.218 327.369C150.307 327.453 159.29 335.669 168.322 331.503C168.407 331.465 168.509 331.501 168.549 331.587C168.589 331.672 168.549 331.774 168.466 331.814C161.723 334.923 155.027 331.306 151.867 329.09C154.284 331.361 159.086 334.941 164.236 333.573C164.327 333.548 164.421 333.604 164.445 333.695C164.47 333.786 164.414 333.881 164.323 333.905C163.505 334.123 162.696 334.22 161.903 334.22H161.905Z",
    fill: "url(#paint34_linear_376_4207)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M162.839 331.528C159.402 331.528 155.118 330.565 150.017 327.642C149.939 327.597 149.908 327.498 149.948 327.416C149.988 327.334 150.088 327.302 150.168 327.334C150.274 327.38 160.746 331.727 170.927 326.519C175.499 324.18 176.904 320.194 176.917 320.154C176.948 320.065 177.043 320.016 177.135 320.047C177.224 320.078 177.272 320.174 177.243 320.265C177.228 320.305 175.784 324.421 171.084 326.825C163.366 330.774 155.483 329.305 151.95 328.294C165.514 335.125 172.658 327.73 172.733 327.649C172.797 327.578 172.906 327.578 172.975 327.642C173.044 327.708 173.047 327.815 172.982 327.884C172.931 327.939 169.465 331.528 162.839 331.528Z",
    fill: "url(#paint35_linear_376_4207)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M156.08 328.225C152.549 328.225 150.105 327.672 150.065 327.661C149.978 327.641 149.919 327.555 149.934 327.466C149.948 327.377 150.018 327.311 150.119 327.322C150.172 327.327 155.629 327.812 163.428 324.873C171.355 321.886 178.639 314.777 177.112 308.045C177.092 307.952 177.148 307.861 177.241 307.839C177.334 307.821 177.426 307.878 177.446 307.969C179.016 314.883 171.613 322.158 163.548 325.195C158.631 327.047 154.631 327.55 152.303 327.666C154.798 327.956 159.159 328.145 163.785 326.914C170.116 325.23 177.612 320.679 177.901 313.399C177.905 313.304 177.972 313.242 178.079 313.233C178.174 313.237 178.247 313.317 178.245 313.412C177.948 320.877 170.318 325.53 163.874 327.244C161.061 327.992 158.346 328.221 156.078 328.221L156.08 328.225Z",
    fill: "url(#paint36_linear_376_4207)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150.103 327.666C150.023 327.666 149.954 327.611 149.936 327.531C149.917 327.445 149.965 327.36 150.046 327.331C150.119 327.305 157.406 324.747 164.552 318.18C171.627 311.679 175.293 304.8 173.671 301.063C173.633 300.976 173.673 300.876 173.76 300.837C173.846 300.801 173.948 300.839 173.986 300.927C175.692 304.858 172.078 311.729 164.783 318.433C159.526 323.265 154.191 325.941 151.663 327.047C154.367 326.479 160.17 324.849 166.176 320.562C175.17 314.14 176.904 307.821 175.655 304.363C175.622 304.274 175.67 304.175 175.759 304.143C175.848 304.112 175.946 304.157 175.979 304.246C177.268 307.819 175.526 314.309 166.376 320.843C158.104 326.746 150.199 327.657 150.121 327.666C150.116 327.666 150.108 327.666 150.103 327.666Z",
    fill: "url(#paint37_linear_376_4207)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M255.84 160.281C255.84 158.502 255.695 156.735 255.409 154.976V154.971C254.796 151.196 253.371 146.975 251.276 143.209H251.278C251.278 143.209 251.269 143.197 251.265 143.191C250.072 141.011 248.647 138.881 247.001 136.81C247.001 136.81 246.997 136.809 246.988 136.805C246.128 135.711 244.688 134.055 243.368 132.713C243.368 132.713 243.368 132.713 243.366 132.713C242.246 131.568 241.047 130.439 239.782 129.348C239.782 129.348 239.776 129.343 239.773 129.343C238.569 128.294 237.305 127.278 235.974 126.283C235.969 126.283 235.969 126.278 235.961 126.278C232.505 123.681 228.262 121.072 223.996 118.908C223.991 118.908 223.983 118.908 223.978 118.903C219.839 116.791 214.984 114.753 210.134 113.101C207.143 112.062 203.223 110.9 199.715 110.024C197.969 109.581 196.173 109.179 194.354 108.793V108.784C194.354 108.784 194.338 108.788 194.331 108.788C192.587 108.418 190.812 108.074 189.001 107.757V107.75C189.001 107.75 188.988 107.751 188.981 107.753C174.697 105.253 159.553 104.581 144.59 105.448C144.59 105.448 144.59 105.448 144.59 105.446V105.448C142.42 105.57 140.28 105.734 138.183 105.934C135.365 106.196 132.606 106.517 129.922 106.899H129.91C126.64 107.36 122.86 107.995 119.168 108.786C119.168 108.786 119.165 108.786 119.163 108.786C119.163 108.786 119.163 108.786 119.163 108.788C117.344 109.17 115.562 109.583 113.817 110.026C113.811 110.026 113.817 110.026 113.804 110.026C112.085 110.457 110.403 110.918 108.756 111.402C108.752 111.402 108.751 111.402 108.747 111.402V111.406C106.918 111.94 105.136 112.504 103.404 113.105C103.397 113.105 103.39 113.105 103.383 113.105V113.11C101.721 113.673 100.091 114.27 98.511 114.899C98.5056 114.899 98.5001 114.899 98.4947 114.899C96.9727 115.494 95.4943 116.119 94.0577 116.762H94.045C92.8994 117.271 91.1192 118.104 89.5626 118.903C89.5572 118.903 89.5535 118.903 89.5481 118.905V118.908C88.1297 119.626 86.7495 120.369 85.4185 121.141C85.4166 121.141 85.4148 121.141 85.413 121.141C84.0092 121.948 82.6563 122.78 81.3525 123.634C81.3525 123.634 81.3525 123.634 81.3507 123.634C80.4251 124.242 78.9449 125.255 77.5684 126.282C77.5647 126.282 77.5629 126.283 77.5593 126.285C76.2282 127.278 74.9608 128.297 73.7624 129.335C73.7624 129.341 73.757 129.341 73.757 129.341C72.4859 130.444 71.2894 131.564 70.1692 132.715C70.1656 132.717 70.162 132.719 70.1601 132.721H70.162C69.1909 133.711 67.7326 135.315 66.536 136.818C66.536 136.818 66.5324 136.82 66.5324 136.821C64.8958 138.884 63.4756 141 62.2882 143.169C62.2791 143.182 62.2719 143.193 62.2628 143.206H62.2646C61.2081 145.121 60.3334 147.079 59.6442 149.06C59.6406 149.069 59.6352 149.078 59.6315 149.087H59.6333C58.9551 151.021 58.4586 152.973 58.1368 154.951C58.135 154.96 58.1313 154.967 58.1295 154.976C57.8622 156.559 57.664 159.032 57.6985 161.044C57.6985 161.046 57.6985 161.048 57.6985 161.051C57.8531 166.015 57.213 180.892 58.3532 185.538C58.3586 185.556 58.3586 185.574 58.3659 185.592C58.3968 185.747 58.3659 185.596 58.4441 185.966C58.7623 187.457 59.3988 189.675 60.1607 191.594C60.1898 191.674 60.2189 191.751 60.2461 191.824C60.8517 193.33 61.5609 194.81 62.3791 196.28C62.3846 196.298 62.3973 196.311 62.4028 196.329C62.9356 197.281 63.512 198.223 64.1357 199.157C64.2576 199.352 64.3539 199.497 64.4267 199.594C65.3504 200.952 66.3724 202.294 67.4871 203.611C67.4962 203.624 67.5053 203.638 67.5162 203.651V203.647C67.5162 203.647 67.518 203.647 67.5198 203.647C68.1726 204.419 69.2818 205.661 70.4729 206.865C71.5203 207.914 72.6223 208.944 73.7897 209.95C73.7897 209.95 73.7915 209.951 73.7933 209.953C73.7933 209.957 73.7933 209.959 73.7988 209.962C75.0589 211.049 76.3864 212.111 77.7866 213.149C77.7866 213.149 77.7908 213.153 77.7993 213.162C79.4377 214.373 81.1797 215.553 83.0109 216.685C83.0181 216.691 83.0236 216.696 83.0309 216.702C84.3983 217.549 85.8221 218.373 87.2932 219.175C87.2951 219.175 87.2969 219.178 87.2987 219.18C88.7607 219.978 90.2718 220.746 91.8375 221.478C91.8465 221.485 91.8538 221.491 91.8611 221.498C93.0012 222.043 94.8597 222.879 96.6235 223.607C96.629 223.611 96.6326 223.616 96.6381 223.62V223.614C98.491 224.386 100.402 225.116 102.373 225.812C102.373 225.812 102.375 225.812 102.377 225.814C102.377 225.816 102.382 225.818 102.382 225.818C103.737 226.295 105.881 227.003 107.712 227.551C107.718 227.555 107.723 227.56 107.73 227.564V227.557C109.445 228.079 111.2 228.567 112.991 229.024C112.998 229.028 113.006 229.035 113.013 229.039V229.03C114.509 229.425 116.877 229.993 118.894 230.417C118.897 230.417 118.899 230.421 118.903 230.423V230.419C120.825 230.831 122.787 231.211 124.793 231.555C124.796 231.555 124.798 231.559 124.802 231.561H124.803C126.782 231.9 128.799 232.209 130.855 232.482C130.915 232.5 130.952 232.504 130.952 232.504V232.5C133.014 232.777 135.116 233.025 137.26 233.236C139.302 233.436 141.382 233.606 143.491 233.741C143.491 233.741 143.493 233.741 143.495 233.741C143.495 233.741 143.497 233.744 143.499 233.746V233.741C145.775 233.892 148.088 234.001 150.443 234.068C150.443 234.07 150.443 234.072 150.443 234.074V234.068C154.235 234.189 158.802 234.205 163.061 234.068V234.072C163.061 234.072 163.061 234.07 163.061 234.068C165.416 234.001 167.729 233.892 170.006 233.741V233.746L170.011 233.741C173.893 233.493 178.288 233.081 182.553 232.502C182.553 232.502 182.571 232.502 182.594 232.497C184.217 232.28 186.699 231.909 188.701 231.561C188.701 231.561 188.703 231.561 188.704 231.561C190.706 231.217 192.674 230.836 194.598 230.419V230.425C194.598 230.425 194.609 230.417 194.612 230.415C196.171 230.088 198.529 229.543 200.484 229.035V229.041C200.484 229.041 200.493 229.035 200.497 229.032C201.837 228.689 203.91 228.127 205.774 227.555V227.562C205.774 227.562 205.787 227.553 205.792 227.549C207.207 227.125 209.351 226.44 211.116 225.819C211.116 225.819 211.116 225.818 211.118 225.818C211.118 225.818 211.124 225.814 211.125 225.812C213.1 225.122 215.008 224.384 216.861 223.611V223.62C216.87 223.614 216.877 223.607 216.883 223.601C218.519 222.931 220.103 222.227 221.645 221.491V221.495C221.645 221.495 221.654 221.487 221.658 221.485C222.827 220.936 224.609 220.047 226.204 219.18C227.675 218.379 229.099 217.554 230.468 216.705C230.468 216.705 230.472 216.704 230.473 216.702C233.485 214.835 236.723 212.543 239.696 209.966C239.696 209.966 239.702 209.962 239.704 209.959C240.875 208.946 241.982 207.91 243.031 206.856L243.035 206.861C243.044 206.85 243.051 206.838 243.06 206.827C244.977 204.906 247.188 202.363 248.974 199.75L248.979 199.745C248.987 199.732 248.996 199.721 249.003 199.708C249.059 199.636 249.19 199.461 249.363 199.173C249.363 199.171 249.365 199.169 249.367 199.168C250.705 197.15 252.185 194.499 253.264 191.816C253.265 191.809 253.269 191.8 253.271 191.793C253.305 191.703 253.34 191.607 253.378 191.507C254.095 189.693 254.649 187.861 255.051 186.009H255.055C256.368 181.304 255.644 165.296 255.815 160.277L255.84 160.281ZM171.939 171.966C170.289 172.13 168.598 172.263 166.878 172.367H166.872C165.169 172.476 163.436 172.554 161.672 172.603C158.779 172.691 155.215 172.705 151.854 172.603C148.743 172.514 145.113 172.312 141.586 171.966C141.586 171.966 141.58 171.971 141.58 171.966C139.96 171.815 138.369 171.627 136.816 171.427V171.42C136.816 171.42 136.809 171.423 136.805 171.425C134.03 171.043 130.995 170.551 127.831 169.872C127.831 169.872 127.827 169.872 127.826 169.872C127.597 169.823 127.373 169.775 127.149 169.721C128.204 169.462 130.875 168.918 133.065 168.555H133.07C134.252 168.355 135.592 168.149 137.071 167.942C137.089 167.942 137.107 167.936 137.138 167.929C140.005 167.547 143.444 167.181 146.954 166.94C146.954 166.94 146.954 166.94 146.955 166.94C153.078 166.521 159.97 166.483 166.565 166.94H166.571C168.093 167.044 169.553 167.164 170.94 167.299L170.946 167.304C172.915 167.492 174.741 167.705 176.388 167.929H176.394C177.452 168.075 179.069 168.313 180.443 168.543C180.449 168.546 180.454 168.552 180.46 168.555V168.546C181.551 168.727 183.12 169.009 184.246 169.242C184.253 169.247 184.26 169.255 184.267 169.26V169.247C185.664 169.53 186.42 169.715 186.42 169.715C186.184 169.77 185.942 169.825 185.699 169.874C183.129 170.431 179.878 171.006 176.716 171.422C176.716 171.422 176.716 171.427 176.71 171.422C175.159 171.635 173.57 171.817 171.946 171.968H171.94L171.939 171.966Z",
    fill: "#141332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.394 167.929C176.448 167.947 176.472 167.947 176.472 167.947L176.394 167.929Z",
    fill: "#141332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M156.773 234.34C127.435 234.34 102.202 228.469 83.8001 217.365C66.8597 207.142 57.5312 193.506 57.5312 178.969V160.281C57.5312 145.744 66.8597 132.109 83.8001 121.886C102.201 110.78 127.435 104.911 156.773 104.911C186.111 104.911 211.344 110.781 229.746 121.886C246.684 132.109 256.015 145.744 256.015 160.281V178.969C256.015 193.506 246.686 207.142 229.746 217.365C211.344 228.471 186.111 234.34 156.773 234.34ZM156.773 105.251C127.498 105.251 102.324 111.104 83.9764 122.177C67.1434 132.336 57.8731 145.868 57.8731 160.279V178.968C57.8731 193.379 67.1434 206.91 83.9764 217.068C102.324 228.141 127.497 233.994 156.773 233.994C186.049 233.994 211.22 228.141 229.568 217.068C246.401 206.909 255.671 193.379 255.671 178.968V160.279C255.671 145.868 246.401 132.336 229.568 122.177C211.22 111.104 186.048 105.251 156.773 105.251Z",
    fill: "url(#paint38_linear_376_4207)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M127.153 169.89C127.077 169.89 127.006 169.837 126.988 169.761C126.964 169.668 127.021 169.575 127.111 169.553C127.237 169.522 139.817 166.434 156.766 166.434C173.716 166.434 186.339 169.515 186.465 169.546C186.555 169.57 186.612 169.663 186.588 169.754C186.566 169.845 186.475 169.901 186.381 169.879C186.257 169.848 173.668 166.776 156.766 166.776C139.864 166.776 127.319 169.854 127.195 169.885C127.181 169.888 127.168 169.89 127.153 169.89Z",
    fill: "url(#paint39_linear_376_4207)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M156.766 166.776C156.671 166.776 156.595 166.7 156.595 166.605V105.082C156.595 104.987 156.671 104.911 156.766 104.911C156.86 104.911 156.937 104.987 156.937 105.082V166.605C156.937 166.7 156.86 166.776 156.766 166.776Z",
    fill: "url(#paint40_linear_376_4207)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M151.598 166.869C151.569 166.869 151.54 166.862 151.514 166.848C151.433 166.802 151.404 166.698 151.449 166.616C151.491 166.536 152.405 164.604 152.405 151.249V126.107C152.405 115.737 151.598 108.001 150.847 105.202C150.822 105.111 150.876 105.017 150.969 104.993C151.06 104.969 151.154 105.024 151.178 105.113C151.934 107.932 152.747 115.704 152.747 126.107V151.249C152.747 164.857 151.789 166.711 151.747 166.784C151.716 166.84 151.658 166.871 151.598 166.871V166.869Z",
    fill: "url(#paint41_linear_376_4207)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M146.955 167.11C146.919 167.11 146.883 167.099 146.852 167.075C146.777 167.019 146.763 166.911 146.817 166.837C146.843 166.798 148.283 164.58 148.283 151.249V137.22C148.283 120.127 146.039 108.393 144.444 105.517C144.399 105.433 144.428 105.33 144.512 105.284C144.593 105.239 144.699 105.268 144.744 105.351C146.355 108.258 148.625 120.067 148.625 137.22V151.249C148.625 164.87 147.154 166.96 147.09 167.044C147.055 167.088 147.005 167.111 146.954 167.111L146.955 167.11Z",
    fill: "url(#paint42_linear_376_4207)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M142.58 167.472C142.518 167.472 142.46 167.439 142.429 167.381C142.385 167.299 142.413 167.198 142.491 167.153C142.578 167.091 144.253 165.705 144.253 151.809V137.22C144.253 121.372 141.885 109.428 138.072 106.05C138.001 105.988 137.996 105.879 138.057 105.808C138.121 105.737 138.228 105.73 138.299 105.794C142.182 109.235 144.595 121.277 144.595 137.22V151.809C144.595 165.997 142.858 167.344 142.66 167.45C142.634 167.464 142.607 167.47 142.578 167.47L142.58 167.472Z",
    fill: "url(#paint43_linear_376_4207)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M137.054 168.119C136.963 168.119 136.888 168.048 136.883 167.956C136.878 167.864 136.948 167.782 137.041 167.776C137.094 167.769 140.216 167.215 140.216 152.385V137.222C140.216 122.98 134.821 107.196 129.908 107.061C129.813 107.06 129.738 106.98 129.74 106.885C129.742 106.792 129.818 106.717 129.911 106.717H129.917C135.397 106.867 140.558 124.029 140.558 137.22V152.384C140.558 167.738 137.207 168.109 137.063 168.117C137.059 168.117 137.056 168.117 137.052 168.117L137.054 168.119Z",
    fill: "url(#paint44_linear_376_4207)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M133.067 168.723C133.01 168.723 132.956 168.695 132.923 168.644C132.872 168.564 132.894 168.459 132.974 168.408C135.623 166.691 136.609 162.508 136.609 152.973V138.708C136.609 125.613 130.743 108.327 124.513 107.911C124.418 107.906 124.347 107.824 124.353 107.729C124.358 107.635 124.422 107.564 124.535 107.569C130.93 107.995 136.951 125.473 136.951 138.708V152.973C136.951 162.644 135.923 166.905 133.159 168.697C133.13 168.715 133.098 168.725 133.067 168.725V168.723Z",
    fill: "url(#paint45_linear_376_4207)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M129.258 169.426C129.205 169.426 129.154 169.402 129.122 169.356C129.065 169.28 129.08 169.172 129.156 169.116C132.211 166.82 133.193 163.043 133.193 153.576V139.371C133.193 125.333 125.847 109.406 119.157 108.942C119.062 108.935 118.991 108.853 118.999 108.758C119.006 108.664 119.091 108.592 119.182 108.598C126.576 109.111 133.539 126.369 133.539 139.369V153.574C133.539 163.171 132.524 167.015 129.365 169.389C129.334 169.413 129.298 169.424 129.262 169.424L129.258 169.426Z",
    fill: "url(#paint46_linear_376_4207)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M125.992 169.624C125.939 169.624 125.888 169.601 125.856 169.555C125.799 169.479 125.814 169.371 125.89 169.315C129.013 166.969 129.914 163.611 129.914 154.35V140.155C129.914 126.101 121.482 110.415 113.803 110.184C113.709 110.18 113.634 110.102 113.638 110.008C113.64 109.915 113.716 109.842 113.809 109.842H113.814C122.283 110.099 130.258 127.137 130.258 140.157V154.352C130.258 163.746 129.325 167.166 126.098 169.591C126.067 169.615 126.03 169.626 125.994 169.626L125.992 169.624Z",
    fill: "url(#paint47_linear_376_4207)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.05 169.147C124.012 169.147 123.972 169.135 123.941 169.107C123.868 169.047 123.859 168.938 123.919 168.865C126.096 166.243 126.794 162.94 126.794 155.268V141.035C126.794 128.243 118.044 111.652 108.75 111.559C108.656 111.559 108.579 111.481 108.581 111.386C108.581 111.291 108.659 111.217 108.752 111.217H108.754C113.225 111.261 117.915 114.975 121.619 121.407C125.072 127.405 127.136 134.742 127.136 141.035V155.268C127.136 163.032 126.418 166.39 124.183 169.084C124.149 169.124 124.099 169.145 124.05 169.145V169.147Z",
    fill: "url(#paint48_linear_376_4207)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 168.561C121.86 168.561 121.83 168.553 121.803 168.537C121.721 168.488 121.694 168.384 121.743 168.302C123.78 164.859 123.78 161.565 123.778 156.577V141.978C123.778 133.283 119.425 122.936 113.428 117.379C110.24 114.425 106.769 113.001 103.399 113.263C103.288 113.273 103.221 113.2 103.215 113.105C103.208 113.01 103.279 112.928 103.374 112.921C106.858 112.648 110.402 114.107 113.66 117.126C119.721 122.743 124.12 133.194 124.12 141.978V156.577C124.12 161.441 124.12 164.953 122.036 168.477C122.003 168.532 121.947 168.561 121.889 168.561H121.89Z",
    fill: "url(#paint49_linear_376_4207)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M119.752 167.92C119.728 167.92 119.704 167.914 119.681 167.905C119.595 167.865 119.557 167.763 119.595 167.678C120.957 164.697 120.957 161.754 120.957 157.302V143.04C120.957 134.663 116.371 124.603 110.054 119.116C106.363 115.911 102.377 114.507 98.5235 115.059C98.4289 115.07 98.3434 115.008 98.3307 114.913C98.318 114.82 98.3816 114.733 98.4762 114.718C102.429 114.154 106.512 115.583 110.28 118.857C116.666 124.404 121.301 134.574 121.301 143.042V157.304C121.301 161.639 121.301 164.771 119.91 167.822C119.881 167.885 119.819 167.922 119.753 167.922L119.752 167.92Z",
    fill: "url(#paint50_linear_376_4207)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M117.661 167.228C117.644 167.228 117.626 167.226 117.61 167.221C117.519 167.192 117.47 167.095 117.499 167.006C118.257 164.606 118.295 162.186 118.295 158.436V144.171C118.295 136.104 113.787 126.659 107.332 121.201C103.122 117.641 98.5327 116.163 94.0758 116.922C93.9776 116.94 93.8939 116.875 93.8776 116.782C93.8612 116.689 93.9248 116.6 94.0176 116.583C98.5836 115.806 103.264 117.312 107.554 120.939C114.08 126.456 118.637 136.009 118.637 144.171V158.436C118.637 162.218 118.597 164.659 117.824 167.108C117.801 167.181 117.733 167.228 117.661 167.228Z",
    fill: "url(#paint51_linear_376_4207)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M115.599 166.472C115.586 166.472 115.573 166.472 115.561 166.469C115.468 166.449 115.41 166.356 115.432 166.265C115.812 164.573 115.81 162.843 115.808 160.223V145.515C115.808 137.69 110.986 128.197 104.339 122.942C101.061 120.349 95.8399 117.572 89.5901 119.063C89.4955 119.087 89.4064 119.029 89.3846 118.936C89.3627 118.843 89.4191 118.75 89.5119 118.728C94.5634 117.523 99.7677 118.887 104.554 122.673C111.273 127.988 116.152 137.594 116.152 145.515V160.223C116.153 162.865 116.155 164.611 115.768 166.339C115.75 166.42 115.679 166.474 115.601 166.474L115.599 166.472Z",
    fill: "url(#paint52_linear_376_4207)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M113.57 165.653C113.57 165.653 113.555 165.653 113.546 165.653C113.451 165.64 113.386 165.552 113.399 165.46C113.528 164.531 113.522 163.68 113.513 162.275C113.511 161.87 113.508 161.421 113.508 160.907V146.745C113.508 139.125 108.474 129.865 101.539 124.73C97.8948 122.031 92.1504 119.245 85.4641 121.297C85.375 121.327 85.2786 121.274 85.2495 121.183C85.2223 121.092 85.2732 120.995 85.3641 120.968C92.185 118.877 98.0384 121.707 101.744 124.453C108.873 129.732 113.851 138.899 113.851 146.745V160.907C113.851 161.419 113.853 161.869 113.857 162.273C113.864 163.695 113.87 164.553 113.739 165.507C113.726 165.592 113.653 165.654 113.568 165.654L113.57 165.653Z",
    fill: "url(#paint53_linear_376_4207)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.543 164.742C111.543 164.742 111.538 164.742 111.536 164.742C111.442 164.738 111.369 164.658 111.372 164.564C111.4 163.977 111.411 163.258 111.411 162.233V148.384C111.411 140.627 106.365 131.682 99.14 126.635C93.4738 122.676 87.1785 121.663 81.4123 123.787C81.3232 123.819 81.225 123.774 81.1923 123.685C81.1595 123.595 81.205 123.497 81.2941 123.464C87.1657 121.301 93.5738 122.328 99.3346 126.352C106.646 131.46 111.753 140.519 111.753 148.382V162.231C111.753 163.262 111.74 163.984 111.714 164.576C111.711 164.669 111.634 164.74 111.543 164.74V164.742Z",
    fill: "url(#paint54_linear_376_4207)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M109.692 163.821C109.597 163.821 109.521 163.744 109.521 163.649V149.639C109.521 142.18 104.175 133.265 96.8104 128.441C90.6696 124.418 83.8596 123.706 77.6316 126.434C77.5425 126.473 77.4443 126.432 77.4061 126.345C77.3679 126.258 77.4079 126.157 77.4952 126.119C83.8342 123.344 90.7587 124.065 96.9995 128.153C104.455 133.035 109.865 142.071 109.865 149.637V163.648C109.865 163.742 109.788 163.819 109.694 163.819L109.692 163.821Z",
    fill: "url(#paint55_linear_376_4207)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M108.023 162.898C107.929 162.898 107.852 162.821 107.852 162.727V151.125C107.852 143.659 102.328 134.909 94.7159 130.319C87.946 126.236 80.5323 125.939 73.8405 129.487C73.7587 129.53 73.6532 129.499 73.6096 129.416C73.5659 129.332 73.5969 129.228 73.6805 129.184C80.4832 125.581 88.0169 125.879 94.8941 130.027C102.602 134.676 108.196 143.55 108.196 151.129V162.73C108.196 162.825 108.119 162.901 108.025 162.901L108.023 162.898Z",
    fill: "url(#paint56_linear_376_4207)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 162.031C106.505 162.031 106.429 161.954 106.429 161.86V153.079C106.429 145.316 100.904 136.803 92.9943 132.376C85.577 128.225 77.5014 128.396 70.255 132.861C70.175 132.912 70.0695 132.886 70.0186 132.804C69.9695 132.724 69.9932 132.619 70.075 132.568C77.4286 128.035 85.6297 127.86 93.1616 132.076C101.175 136.561 106.771 145.196 106.771 153.079V161.86C106.771 161.954 106.694 162.031 106.6 162.031Z",
    fill: "url(#paint57_linear_376_4207)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M105.373 161.213C105.279 161.213 105.202 161.137 105.202 161.042V154.366C105.202 146.453 99.2635 138.1 90.7606 134.054C82.505 130.124 73.713 131.18 66.643 136.947C66.5684 137.007 66.4611 136.996 66.4011 136.922C66.3411 136.849 66.352 136.739 66.4247 136.679C73.6038 130.825 82.525 129.754 90.9079 133.742C99.5253 137.843 105.544 146.323 105.544 154.365V161.04C105.544 161.135 105.468 161.211 105.373 161.211V161.213Z",
    fill: "url(#paint58_linear_376_4207)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M104.453 160.548C104.358 160.548 104.282 160.472 104.282 160.377V155.983C104.282 150.307 100.094 140.241 88.5547 135.776C80.8573 132.797 69.3922 132.979 62.4059 143.297C62.3513 143.375 62.2458 143.395 62.1676 143.342C62.0894 143.289 62.0694 143.182 62.1222 143.104C68.7648 133.29 80.2481 132.192 88.6783 135.455C100.378 139.982 104.624 150.213 104.624 155.983V160.377C104.624 160.472 104.548 160.548 104.453 160.548Z",
    fill: "url(#paint59_linear_376_4207)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.797 160.04H103.79C103.695 160.037 103.622 159.957 103.624 159.862C103.77 156.16 103.059 143.639 87.7932 137.928C79.5558 134.845 65.4176 136.288 59.7914 149.147C59.7532 149.235 59.6532 149.273 59.5659 149.237C59.4786 149.198 59.4405 149.098 59.4786 149.011C65.1939 135.947 79.5467 134.476 87.915 137.606C103.395 143.397 104.117 156.114 103.968 159.875C103.964 159.968 103.888 160.04 103.797 160.04Z",
    fill: "url(#paint60_linear_376_4207)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M103.397 159.717C103.308 159.717 103.231 159.647 103.226 159.556C102.853 154.201 100.298 144.568 87.3729 140.223C81.414 138.22 74.2276 138.837 68.6105 141.831C63.4826 144.564 59.9185 149.122 58.3001 155.011C58.2746 155.102 58.1855 155.157 58.0892 155.131C57.9982 155.106 57.9437 155.011 57.9692 154.92C59.613 148.938 63.2353 144.308 68.4487 141.527C74.1439 138.49 81.4376 137.865 87.4802 139.897C100.595 144.306 103.188 154.092 103.566 159.533C103.573 159.627 103.502 159.709 103.408 159.717C103.404 159.717 103.4 159.717 103.395 159.717H103.397Z",
    fill: "url(#paint61_linear_376_4207)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7039 161.213C57.7039 161.213 57.6948 161.213 57.6894 161.213C57.5948 161.206 57.5239 161.122 57.533 161.027C58.2258 152.649 62.8973 147.887 66.6942 145.369C72.7222 141.37 81.0887 140.106 87.5187 142.226C96.4343 145.165 101.715 150.883 103.215 159.223C103.232 159.316 103.17 159.405 103.077 159.423C102.984 159.436 102.895 159.377 102.879 159.285C101.404 151.078 96.1998 145.447 87.4132 142.552C81.0797 140.465 72.8295 141.712 66.8833 145.655C63.1501 148.131 58.5568 152.813 57.8749 161.055C57.8676 161.144 57.793 161.213 57.7039 161.213Z",
    fill: "url(#paint62_linear_376_4207)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4619 186.184C58.3856 186.184 58.3147 186.131 58.2947 186.053C57.8782 184.349 57.8164 181.036 57.8164 179.213V166.057C57.8164 149.827 72.4346 143.774 81.6485 143.772H81.6558C94.3702 143.772 101.149 152.034 103.093 159.11C103.119 159.201 103.064 159.296 102.973 159.321C102.879 159.347 102.788 159.292 102.762 159.201C100.851 152.241 94.1756 144.116 81.6558 144.116H81.6485C72.5674 144.118 58.1583 150.078 58.1583 166.059V179.215C58.1583 181.022 58.2201 184.303 58.6274 185.973C58.6492 186.066 58.5929 186.159 58.5019 186.181C58.4874 186.184 58.4747 186.186 58.4619 186.186V186.184Z",
    fill: "url(#paint63_linear_376_4207)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2533 191.988C60.1842 191.988 60.1187 191.946 60.0932 191.877C59.6623 190.742 58.6494 188.087 58.6494 182.557V168.861C58.6494 165.285 59.6786 156.308 69.2108 150.216C78.9138 144.016 88.7496 146.09 93.032 148.295C97.7635 150.73 101.089 154.312 102.919 158.944C102.953 159.032 102.911 159.132 102.822 159.167C102.733 159.203 102.635 159.157 102.6 159.07C100.802 154.518 97.5289 150.996 92.8756 148.599C88.6569 146.431 78.9666 144.389 69.3962 150.506C60.006 156.506 58.9913 165.341 58.9913 168.861V182.557C58.9913 188.023 59.9859 190.636 60.4115 191.755C60.446 191.844 60.4006 191.942 60.3133 191.977C60.2933 191.984 60.2733 191.988 60.2514 191.988H60.2533Z",
    fill: "url(#paint64_linear_376_4207)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4154 196.493C62.3535 196.493 62.2935 196.46 62.2626 196.4C59.9405 191.94 59.9823 187.98 60.0023 186.077C60.0041 185.922 60.006 185.782 60.006 185.656V172.145C60.006 164.18 63.4009 157.903 70.3873 152.952C77.1845 148.135 86.8403 147.048 93.8721 150.308C100.262 153.27 102.786 158.786 102.81 158.842C102.848 158.928 102.81 159.03 102.722 159.068C102.637 159.108 102.535 159.068 102.495 158.983C102.471 158.928 99.9947 153.527 93.7266 150.621C86.8039 147.409 77.2863 148.485 70.5855 153.232C63.6973 158.112 60.3478 164.3 60.3478 172.145V185.656C60.3478 185.784 60.3478 185.926 60.3442 186.081C60.3242 187.956 60.2842 191.858 62.5663 196.242C62.6099 196.325 62.5772 196.429 62.4935 196.473C62.4681 196.486 62.4408 196.493 62.4154 196.493Z",
    fill: "url(#paint65_linear_376_4207)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5488 199.9C64.4997 199.9 64.4524 199.88 64.4197 199.84C64.3142 199.716 61.8193 196.74 61.8193 189.295V175.224C61.8193 167.102 65.1452 160.705 71.9897 155.663C77.7159 151.442 84.7423 149.796 91.2649 151.143C96.3165 152.187 100.477 154.947 102.683 158.719C102.73 158.801 102.703 158.906 102.621 158.954C102.541 159.001 102.434 158.974 102.386 158.892C100.23 155.204 96.1528 152.502 91.1958 151.478C84.7677 150.151 77.8414 151.777 72.1934 155.938C65.4434 160.911 62.163 167.219 62.163 175.224V189.295C62.163 196.598 64.6561 199.587 64.6815 199.616C64.7433 199.687 64.7343 199.796 64.6633 199.858C64.6306 199.885 64.5906 199.9 64.5524 199.9H64.5488Z",
    fill: "url(#paint66_linear_376_4207)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5269 203.815C67.4742 203.815 67.4233 203.791 67.3905 203.745C64.1865 199.47 64.0938 194.049 64.0938 193.444V178.024C64.0938 161.716 78.3301 154.248 85.2255 153.186C97.1707 151.345 102.484 158.507 102.537 158.58C102.591 158.656 102.575 158.764 102.499 158.819C102.422 158.873 102.315 158.857 102.259 158.78C102.208 158.709 97.0107 151.72 85.2783 153.525C78.4774 154.572 64.4374 161.938 64.4374 178.022V193.442C64.4374 194.034 64.5284 199.351 67.6651 203.538C67.7215 203.614 67.7069 203.722 67.6306 203.778C67.5997 203.802 67.5633 203.813 67.5269 203.813V203.815Z",
    fill: "url(#paint67_linear_376_4207)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M70.484 207.032C70.4349 207.032 70.3858 207.011 70.3512 206.969C67.9437 204.026 66.7217 199.843 66.7217 194.537V180.709C66.7217 166.716 78.4505 157.449 86.3769 155.592C92.7996 154.088 97.7238 154.955 102.344 158.403C102.421 158.46 102.435 158.567 102.379 158.644C102.323 158.72 102.215 158.737 102.139 158.678C97.6074 155.295 92.7723 154.445 86.4533 155.925C78.6341 157.757 67.0635 166.9 67.0635 180.707V194.535C67.0635 199.759 68.2582 203.869 70.6149 206.75C70.6749 206.823 70.664 206.932 70.5913 206.992C70.5604 207.018 70.5203 207.031 70.4822 207.031L70.484 207.032Z",
    fill: "url(#paint68_linear_376_4207)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8132 210.132C73.7641 210.132 73.715 210.11 73.6805 210.07C69.8654 205.45 69.8745 200.799 69.8782 197.72V197.376V183.548C69.8782 169.051 81.356 159.611 89.508 157.539C95.105 156.115 99.5711 156.814 103.988 159.804C104.066 159.857 104.086 159.964 104.033 160.043C103.981 160.121 103.873 160.141 103.795 160.088C99.4656 157.158 95.085 156.475 89.5916 157.872C81.5469 159.919 70.22 169.237 70.22 183.549V197.722C70.2146 200.75 70.2055 205.328 73.9423 209.851C74.0023 209.924 73.9932 210.032 73.9187 210.094C73.886 210.119 73.8478 210.134 73.8096 210.134L73.8132 210.132Z",
    fill: "url(#paint69_linear_376_4207)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M77.812 213.329C77.7629 213.329 77.7157 213.309 77.6829 213.271C73.3715 208.296 73.3897 203.724 73.4006 200.697V200.242V186.439C73.4006 170.823 85.1057 161.621 92.483 159.489C99.3693 157.5 103.874 159.726 105.947 161.228C106.023 161.284 106.041 161.39 105.985 161.468C105.928 161.545 105.821 161.561 105.747 161.507C103.724 160.041 99.3275 157.87 92.5794 159.818C85.2966 161.924 73.7442 171.01 73.7442 186.437V200.697C73.7315 203.671 73.7133 208.167 77.9393 213.044C78.0012 213.115 77.9939 213.224 77.923 213.286C77.8902 213.313 77.8502 213.328 77.8102 213.328L77.812 213.329Z",
    fill: "url(#paint70_linear_376_4207)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0414 216.871C83.005 216.871 82.9705 216.86 82.9396 216.836C78.0662 213.205 77.3389 207.265 77.3389 204.048V188.868C77.3389 183.746 78.7027 173.953 87.8348 165.931C98.5252 156.539 107.339 162.115 107.426 162.171C107.505 162.224 107.528 162.329 107.475 162.41C107.425 162.49 107.317 162.512 107.239 162.459C107.154 162.402 98.5489 156.976 88.0602 166.19C79.03 174.124 77.6807 183.804 77.6807 188.87V204.05C77.6807 207.204 78.3899 213.022 83.1432 216.563C83.2196 216.62 83.2342 216.727 83.1778 216.804C83.1451 216.849 83.0923 216.873 83.0414 216.873V216.871Z",
    fill: "url(#paint71_linear_376_4207)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3097 219.347C87.2733 219.347 87.237 219.336 87.206 219.311C81.6562 215.059 81.6563 208.784 81.6563 206.42V191.243C81.6563 179.37 87.2479 171.816 91.9376 167.568C100.357 159.942 107.3 162.3 109.227 163.205C109.313 163.245 109.349 163.347 109.309 163.433C109.269 163.518 109.165 163.555 109.08 163.515C107.203 162.632 100.43 160.337 92.1667 167.823C87.5279 172.024 81.9981 179.497 81.9981 191.243V206.42C81.9981 208.737 81.9981 214.89 87.4134 219.038C87.4879 219.096 87.5024 219.204 87.4443 219.278C87.4115 219.322 87.3606 219.346 87.3079 219.346L87.3097 219.347Z",
    fill: "url(#paint72_linear_376_4207)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8732 221.666C91.8369 221.666 91.8005 221.655 91.7696 221.629C86.2998 217.438 86.2998 211.343 86.2998 208.741V193.561C86.2998 189.997 86.2998 179.153 96.3938 169.074C102.447 163.031 108.563 163.182 111.221 164.225C111.31 164.26 111.354 164.36 111.318 164.447C111.283 164.535 111.181 164.578 111.096 164.544C108.515 163.53 102.564 163.397 96.6357 169.317C86.6417 179.294 86.6417 190.032 86.6417 193.559V208.739C86.6417 211.29 86.6417 217.266 91.9787 221.356C92.0533 221.415 92.0678 221.522 92.0096 221.597C91.9769 221.64 91.926 221.664 91.8732 221.664V221.666Z",
    fill: "url(#paint73_linear_376_4207)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6506 223.787C96.6124 223.787 96.576 223.774 96.5433 223.751C91.7972 219.979 91.248 214.325 91.248 210.399V195.222C91.248 189.673 92.5773 179.022 101.482 170.019C106.635 164.808 111.343 164.859 113.691 165.35C113.784 165.37 113.844 165.461 113.824 165.554C113.804 165.647 113.716 165.709 113.62 165.687C111.343 165.208 106.765 165.165 101.726 170.262C92.9064 179.179 91.5899 189.728 91.5899 195.223V210.401C91.5899 214.256 92.1263 219.805 96.756 223.483C96.8306 223.541 96.8415 223.651 96.7833 223.725C96.7488 223.769 96.6997 223.791 96.6487 223.791L96.6506 223.787Z",
    fill: "url(#paint74_linear_376_4207)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M102.397 225.987C102.366 225.987 102.335 225.98 102.308 225.961C97.1324 222.764 96.5342 216.824 96.5342 212.636V197.607C96.5342 189.375 98.7035 181.903 102.98 175.406C109.434 165.604 115.557 166.299 116.722 166.541C116.815 166.56 116.875 166.651 116.855 166.744C116.837 166.836 116.749 166.898 116.651 166.876C115.528 166.647 109.599 165.973 103.266 175.593C99.0254 182.034 96.876 189.442 96.876 197.607V212.636C96.876 216.742 97.4579 222.562 102.486 225.67C102.568 225.719 102.591 225.825 102.542 225.907C102.509 225.96 102.453 225.989 102.397 225.989V225.987Z",
    fill: "url(#paint75_linear_376_4207)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M107.743 227.731C107.712 227.731 107.681 227.724 107.654 227.706C102.139 224.299 102.139 217.423 102.139 214.118V199.089C102.139 190.877 104.161 183.356 108.149 176.737C113.533 167.798 118.615 167.528 120.043 167.663C120.137 167.672 120.206 167.756 120.197 167.851C120.188 167.945 120.105 168.013 120.012 168.005C118.626 167.878 113.72 168.149 108.441 176.915C104.486 183.482 102.481 190.942 102.481 199.091V214.12C102.481 217.363 102.481 224.11 107.832 227.415C107.914 227.464 107.938 227.569 107.888 227.651C107.856 227.704 107.799 227.733 107.743 227.733V227.731Z",
    fill: "url(#paint76_linear_376_4207)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M113.024 229.208C112.995 229.208 112.966 229.201 112.938 229.185C108.034 226.355 108.034 218.033 108.034 214.901V199.874C108.034 196.966 108.469 186.721 114.064 176.941C117.854 170.318 121.401 168.812 123.709 168.714H123.716C123.807 168.714 123.883 168.787 123.887 168.878C123.891 168.972 123.818 169.053 123.723 169.056C121.501 169.151 118.074 170.624 114.362 177.11C108.811 186.816 108.378 196.986 108.378 199.872V214.899C108.378 217.977 108.378 226.155 113.111 228.884C113.193 228.931 113.22 229.037 113.175 229.119C113.142 229.174 113.086 229.205 113.026 229.205L113.024 229.208Z",
    fill: "url(#paint77_linear_376_4207)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M118.914 230.594C118.886 230.594 118.859 230.588 118.834 230.574C114.164 228.126 114.164 219.619 114.164 216.824V201.795C114.164 193.206 115.886 185.356 119.283 178.463C122.012 172.926 125.045 169.812 127.824 169.693H127.831C127.922 169.693 127.999 169.766 128.002 169.857C128.006 169.952 127.933 170.032 127.839 170.036C125.191 170.147 122.261 173.193 119.59 178.614C116.217 185.457 114.506 193.257 114.506 201.793V216.822C114.506 219.566 114.506 227.917 118.994 230.268C119.077 230.312 119.11 230.415 119.067 230.499C119.036 230.557 118.976 230.59 118.914 230.59V230.594Z",
    fill: "url(#paint78_linear_376_4207)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M124.815 231.732C124.791 231.732 124.766 231.727 124.742 231.716C120.56 229.771 120.56 221.329 120.56 217.725V203.152C120.56 185.07 127.55 170.892 132.083 170.524C132.174 170.517 132.261 170.586 132.268 170.681C132.276 170.775 132.207 170.857 132.112 170.864C128.264 171.178 120.903 183.994 120.903 203.15V217.723C120.903 221.262 120.903 229.549 124.887 231.403C124.973 231.443 125.011 231.545 124.971 231.63C124.942 231.692 124.88 231.729 124.816 231.729L124.815 231.732Z",
    fill: "url(#paint79_linear_376_4207)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M130.964 232.677C130.964 232.677 130.953 232.677 130.948 232.677C130.8 232.662 127.342 232.182 127.342 219.047V203.98C127.342 190.674 131.542 173.109 136.759 171.254C136.85 171.219 136.947 171.268 136.978 171.358C137.01 171.447 136.963 171.545 136.874 171.576C131.782 173.386 127.684 190.784 127.684 203.978V219.045C127.684 231.768 130.95 232.329 130.982 232.333C131.075 232.344 131.142 232.429 131.131 232.522C131.122 232.61 131.05 232.675 130.962 232.675L130.964 232.677Z",
    fill: "url(#paint80_linear_376_4207)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M137.272 233.411C137.245 233.411 137.217 233.404 137.192 233.391C134.666 232.047 134.324 225.51 134.324 219.293V204.678C134.324 184.545 139.361 171.953 141.576 171.791C141.683 171.779 141.752 171.855 141.76 171.95C141.767 172.045 141.696 172.126 141.602 172.134C139.876 172.259 134.668 184.003 134.668 204.676V219.291C134.668 222.992 134.668 231.658 137.352 233.085C137.436 233.129 137.466 233.233 137.423 233.317C137.392 233.375 137.332 233.408 137.272 233.408V233.411Z",
    fill: "url(#paint81_linear_376_4207)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M143.509 233.919C143.458 233.919 143.409 233.897 143.376 233.855C141.785 231.881 141.656 226.677 141.656 220.582V205.577C141.656 183.212 144.937 172.651 146.61 172.199C146.704 172.175 146.795 172.228 146.821 172.319C146.846 172.41 146.791 172.505 146.701 172.53C145.317 172.906 142 182.946 142 205.577V220.582C142 226.387 142.125 231.756 143.644 233.639C143.704 233.711 143.693 233.821 143.618 233.881C143.586 233.906 143.549 233.919 143.511 233.919H143.509Z",
    fill: "url(#paint82_linear_376_4207)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M150.458 234.247C150.385 234.247 150.318 234.201 150.294 234.129C149.263 230.929 149.068 226.899 149.068 220.582V205.578C149.068 186.967 150.034 174.911 151.716 172.502C151.771 172.423 151.876 172.405 151.954 172.46C152.032 172.514 152.051 172.622 151.996 172.698C151.218 173.813 149.41 179.245 149.41 205.578V220.582C149.41 226.863 149.603 230.867 150.619 234.023C150.649 234.114 150.599 234.211 150.509 234.24C150.49 234.245 150.472 234.247 150.456 234.247H150.458Z",
    fill: "url(#paint83_linear_376_4207)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M161.932 166.869C161.872 166.869 161.815 166.838 161.784 166.784C161.744 166.711 160.784 164.859 160.784 151.249V126.107C160.784 115.705 161.599 107.933 162.355 105.113C162.379 105.022 162.475 104.967 162.564 104.993C162.655 105.016 162.71 105.111 162.686 105.202C161.935 108.001 161.128 115.736 161.128 126.107V151.249C161.128 164.622 162.046 166.541 162.084 166.616C162.128 166.7 162.097 166.804 162.015 166.847C161.99 166.862 161.961 166.869 161.933 166.869H161.932Z",
    fill: "url(#paint84_linear_376_4207)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M166.574 167.109C166.523 167.109 166.472 167.086 166.439 167.042C166.377 166.96 164.906 164.87 164.906 151.247V137.218C164.906 120.065 167.176 108.256 168.787 105.349C168.832 105.267 168.938 105.238 169.02 105.282C169.103 105.327 169.132 105.433 169.087 105.515C167.492 108.389 165.248 120.125 165.248 137.218V151.247C165.248 164.631 166.699 166.814 166.714 166.836C166.768 166.913 166.752 167.02 166.677 167.075C166.646 167.098 166.61 167.109 166.576 167.109H166.574Z",
    fill: "url(#paint85_linear_376_4207)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M170.953 167.472C170.926 167.472 170.895 167.464 170.869 167.45C170.671 167.342 168.935 165.997 168.935 151.809V137.22C168.935 121.277 171.348 109.235 175.23 105.794C175.301 105.73 175.41 105.737 175.472 105.808C175.534 105.879 175.528 105.987 175.457 106.05C171.644 109.43 169.276 121.374 169.276 137.22V151.809C169.276 165.769 170.968 167.104 171.04 167.153C171.124 167.198 171.151 167.299 171.106 167.382C171.075 167.439 171.015 167.472 170.953 167.472Z",
    fill: "url(#paint86_linear_376_4207)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M176.478 168.118C176.478 168.118 176.47 168.118 176.467 168.118C176.325 168.109 172.972 167.739 172.972 152.385V137.222C172.972 124.029 178.132 106.868 183.613 106.719H183.618C183.711 106.719 183.788 106.792 183.789 106.886C183.791 106.981 183.717 107.059 183.622 107.063C178.709 107.198 173.315 122.982 173.315 137.224V152.387C173.315 167.268 176.459 167.774 176.49 167.778C176.583 167.787 176.652 167.869 176.645 167.962C176.638 168.051 176.565 168.12 176.476 168.12L176.478 168.118Z",
    fill: "url(#paint87_linear_376_4207)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M180.465 168.723C180.432 168.723 180.402 168.714 180.372 168.695C177.608 166.904 176.581 162.643 176.581 152.971V138.706C176.581 125.471 182.602 107.994 188.999 107.567C189.108 107.56 189.175 107.633 189.181 107.728C189.188 107.822 189.115 107.904 189.021 107.91C182.789 108.325 176.923 125.611 176.923 138.706V152.971C176.923 162.506 177.908 166.691 180.558 168.406C180.638 168.457 180.66 168.564 180.609 168.643C180.576 168.694 180.522 168.721 180.465 168.721V168.723Z",
    fill: "url(#paint88_linear_376_4207)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M184.271 169.426C184.235 169.426 184.198 169.415 184.168 169.391C181.009 167.017 179.996 163.174 179.996 153.576V139.371C179.996 126.371 186.957 109.113 194.351 108.6C194.451 108.594 194.527 108.665 194.534 108.76C194.542 108.855 194.471 108.937 194.376 108.944C187.686 109.408 180.34 125.335 180.34 139.372V153.578C180.34 163.045 181.32 166.822 184.375 169.118C184.451 169.174 184.466 169.282 184.409 169.358C184.375 169.404 184.324 169.428 184.273 169.428L184.271 169.426Z",
    fill: "url(#paint89_linear_376_4207)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M187.539 169.624C187.502 169.624 187.466 169.613 187.435 169.589C184.207 167.164 183.274 163.746 183.274 154.35V140.155C183.274 127.135 191.248 110.097 199.718 109.84H199.724C199.817 109.84 199.893 109.913 199.895 110.006C199.897 110.1 199.824 110.179 199.729 110.182C192.05 110.413 183.618 126.101 183.618 140.154V154.348C183.618 163.609 184.52 166.967 187.642 169.313C187.719 169.369 187.733 169.477 187.677 169.553C187.642 169.599 187.591 169.622 187.54 169.622L187.539 169.624Z",
    fill: "url(#paint90_linear_376_4207)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M189.478 169.147C189.429 169.147 189.38 169.125 189.346 169.085C187.109 166.392 186.393 163.034 186.393 155.269V141.037C186.393 134.743 188.455 127.407 191.91 121.408C195.614 114.977 200.303 111.264 204.775 111.218H204.777C204.871 111.218 204.948 111.295 204.948 111.388C204.948 111.482 204.873 111.561 204.779 111.561C195.485 111.653 186.734 128.244 186.734 141.037V155.269C186.734 162.941 187.433 166.244 189.609 168.866C189.669 168.939 189.66 169.047 189.588 169.109C189.555 169.136 189.517 169.149 189.478 169.149V169.147Z",
    fill: "url(#paint91_linear_376_4207)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M191.639 168.561C191.581 168.561 191.525 168.53 191.492 168.477C189.406 164.953 189.408 161.439 189.408 156.577V141.978C189.408 133.196 193.807 122.743 199.87 117.126C203.128 114.105 206.683 112.648 210.156 112.921C210.251 112.928 210.322 113.01 210.315 113.105C210.307 113.2 210.242 113.274 210.131 113.263C206.754 113.009 203.29 114.425 200.102 117.379C194.105 122.936 189.752 133.283 189.752 141.978V156.577C189.752 161.565 189.752 164.859 191.787 168.302C191.834 168.384 191.809 168.49 191.727 168.537C191.699 168.554 191.67 168.561 191.639 168.561Z",
    fill: "url(#paint92_linear_376_4207)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M193.778 167.92C193.712 167.92 193.651 167.883 193.622 167.819C192.23 164.769 192.23 161.637 192.23 157.302V143.04C192.23 134.572 196.866 124.402 203.252 118.855C207.02 115.583 211.102 114.152 215.055 114.716C215.15 114.729 215.213 114.817 215.201 114.911C215.188 115.006 215.099 115.068 215.008 115.057C211.155 114.505 207.169 115.909 203.476 119.114C197.158 124.601 192.572 134.663 192.572 143.038V157.3C192.572 161.752 192.572 164.693 193.933 167.676C193.973 167.761 193.933 167.863 193.847 167.903C193.823 167.914 193.8 167.918 193.776 167.918L193.778 167.92Z",
    fill: "url(#paint93_linear_376_4207)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M195.869 167.228C195.796 167.228 195.729 167.18 195.705 167.108C194.933 164.657 194.893 162.217 194.893 158.436V144.171C194.893 136.009 199.451 126.456 205.976 120.939C210.265 117.313 214.946 115.805 219.512 116.583C219.605 116.599 219.668 116.687 219.652 116.782C219.638 116.874 219.552 116.94 219.454 116.922C214.993 116.162 210.405 117.641 206.198 121.201C199.742 126.658 195.234 136.104 195.234 144.171V158.436C195.234 162.184 195.273 164.602 196.031 167.006C196.06 167.097 196.009 167.193 195.92 167.221C195.902 167.226 195.885 167.228 195.869 167.228Z",
    fill: "url(#paint94_linear_376_4207)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M197.931 166.472C197.853 166.472 197.782 166.417 197.764 166.339C197.375 164.611 197.376 162.865 197.378 160.221V145.513C197.378 137.601 202.259 128 208.981 122.683C212.326 120.039 217.653 117.208 224.043 118.732C224.136 118.754 224.193 118.846 224.171 118.939C224.149 119.03 224.062 119.09 223.965 119.067C217.708 117.574 212.48 120.356 209.194 122.954C202.548 128.212 197.724 137.699 197.724 145.514V160.222C197.722 162.843 197.72 164.573 198.1 166.264C198.12 166.357 198.062 166.448 197.971 166.47C197.958 166.474 197.946 166.474 197.933 166.474L197.931 166.472Z",
    fill: "url(#paint95_linear_376_4207)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M199.96 165.653C199.877 165.653 199.802 165.591 199.789 165.505C199.657 164.551 199.662 163.691 199.671 162.267C199.673 161.865 199.677 161.417 199.677 160.905V146.744C199.677 138.904 204.657 129.741 211.787 124.46C217.033 120.574 222.859 119.336 228.184 120.97C228.275 120.997 228.326 121.093 228.298 121.185C228.271 121.276 228.175 121.327 228.084 121.299C221.394 119.247 215.639 122.037 211.991 124.739C205.054 129.876 200.02 139.132 200.02 146.745V160.907C200.02 161.419 200.018 161.869 200.015 162.271C200.007 163.679 200.002 164.529 200.131 165.46C200.144 165.554 200.078 165.64 199.984 165.653C199.977 165.653 199.967 165.653 199.96 165.653Z",
    fill: "url(#paint96_linear_376_4207)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M201.987 164.742C201.897 164.742 201.82 164.671 201.816 164.578C201.791 163.986 201.778 163.263 201.778 162.233V148.384C201.778 140.525 206.886 131.466 214.2 126.356C219.968 122.326 226.378 121.299 232.251 123.463C232.34 123.495 232.386 123.594 232.353 123.683C232.32 123.772 232.222 123.818 232.133 123.785C226.365 121.66 220.068 122.674 214.394 126.637C207.168 131.686 202.12 140.627 202.12 148.383V162.231C202.12 163.256 202.133 163.975 202.158 164.562C202.162 164.657 202.089 164.737 201.995 164.74C201.993 164.74 201.989 164.74 201.987 164.74V164.742Z",
    fill: "url(#paint97_linear_376_4207)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M203.837 163.821C203.742 163.821 203.666 163.744 203.666 163.65V149.639C203.666 142.075 209.079 133.039 216.537 128.155C222.781 124.065 229.709 123.342 236.048 126.118C236.134 126.156 236.174 126.256 236.137 126.343C236.099 126.431 235.999 126.469 235.912 126.433C229.686 123.705 222.87 124.419 216.726 128.443C209.359 133.268 204.011 142.184 204.011 149.641V163.651C204.011 163.746 203.935 163.822 203.841 163.822L203.837 163.821Z",
    fill: "url(#paint98_linear_376_4207)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M205.506 162.898C205.411 162.898 205.335 162.821 205.335 162.726V151.125C205.335 143.552 210.93 134.682 218.64 130.031C225.523 125.879 233.064 125.579 239.87 129.184C239.954 129.228 239.985 129.332 239.941 129.415C239.898 129.499 239.792 129.532 239.71 129.486C233.015 125.939 225.594 126.236 218.819 130.322C211.205 134.915 205.679 143.661 205.679 151.121V162.723C205.679 162.817 205.602 162.894 205.508 162.894L205.506 162.898Z",
    fill: "url(#paint99_linear_376_4207)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M206.932 162.031C206.837 162.031 206.761 161.954 206.761 161.86V153.079C206.761 145.196 212.36 136.559 220.377 132.072C227.911 127.855 236.112 128.03 243.465 132.562C243.547 132.611 243.571 132.717 243.522 132.799C243.473 132.879 243.367 132.904 243.285 132.855C236.041 128.39 227.963 128.221 220.542 132.373C212.629 136.801 207.103 145.316 207.103 153.081V161.861C207.103 161.956 207.026 162.033 206.932 162.033V162.031Z",
    fill: "url(#paint100_linear_376_4207)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M208.156 161.213C208.062 161.213 207.985 161.137 207.985 161.042V154.366C207.985 146.325 214.006 137.843 222.629 133.74C231.014 129.75 239.937 130.819 247.116 136.676C247.189 136.736 247.199 136.843 247.139 136.918C247.081 136.991 246.972 137.002 246.898 136.943C239.826 131.176 231.034 130.12 222.775 134.052C214.268 138.1 208.327 146.454 208.327 154.368V161.044C208.327 161.139 208.251 161.215 208.156 161.215V161.213Z",
    fill: "url(#paint101_linear_376_4207)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M209.076 160.549C208.982 160.549 208.905 160.472 208.905 160.377V155.983C208.905 150.213 213.151 139.983 224.851 135.456C233.287 132.191 244.777 133.29 251.425 143.109C251.478 143.187 251.458 143.295 251.38 143.348C251.302 143.4 251.196 143.38 251.142 143.302C244.601 133.64 233.287 132.558 224.975 135.776C213.437 140.241 209.247 150.307 209.247 155.983V160.377C209.247 160.472 209.171 160.549 209.076 160.549Z",
    fill: "url(#paint102_linear_376_4207)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M209.734 160.04C209.643 160.04 209.567 159.968 209.563 159.875C209.416 156.114 210.134 143.397 225.616 137.606C233.99 134.476 248.352 135.944 254.069 149.013C254.107 149.1 254.069 149.2 253.981 149.238C253.892 149.277 253.794 149.238 253.756 149.149C248.126 136.286 233.983 134.842 225.738 137.928C210.472 143.639 209.761 156.16 209.907 159.862C209.91 159.957 209.836 160.037 209.741 160.04H209.734Z",
    fill: "url(#paint103_linear_376_4207)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M210.134 159.716C210.134 159.716 210.127 159.716 210.122 159.716C210.027 159.709 209.956 159.627 209.963 159.532C210.342 154.091 212.935 144.305 226.051 139.897C232.095 137.865 239.393 138.491 245.095 141.532C250.31 144.313 253.934 148.943 255.578 154.923C255.604 155.014 255.549 155.109 255.458 155.135C255.364 155.16 255.273 155.106 255.247 155.014C253.631 149.127 250.065 144.569 244.935 141.834C239.313 138.837 232.119 138.22 226.16 140.223C213.235 144.568 210.68 154.201 210.307 159.556C210.302 159.647 210.225 159.716 210.136 159.716H210.134Z",
    fill: "url(#paint104_linear_376_4207)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M255.842 161.213C255.753 161.213 255.678 161.146 255.671 161.055C254.989 152.817 250.396 148.135 246.661 145.658C240.711 141.711 232.455 140.461 226.116 142.55C217.331 145.445 212.127 151.079 210.651 159.296C210.634 159.389 210.542 159.45 210.452 159.434C210.358 159.418 210.298 159.328 210.314 159.234C211.816 150.885 217.097 145.159 226.011 142.222C232.443 140.103 240.818 141.366 246.852 145.369C250.648 147.887 255.32 152.649 256.013 161.024C256.02 161.118 255.951 161.2 255.856 161.209C255.851 161.209 255.847 161.209 255.842 161.209V161.213Z",
    fill: "url(#paint105_linear_376_4207)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M255.084 186.184C255.071 186.184 255.056 186.184 255.044 186.179C254.953 186.157 254.896 186.064 254.918 185.971C255.125 185.124 255.373 183.265 255.373 179.213V166.057C255.373 150.076 240.965 144.118 231.884 144.114H231.877C219.357 144.114 212.682 152.247 210.769 159.214C210.743 159.305 210.654 159.359 210.558 159.334C210.467 159.308 210.412 159.214 210.438 159.123C212.384 152.041 219.166 143.772 231.877 143.772H231.884C241.098 143.774 255.716 149.827 255.716 166.057V179.213C255.716 182.493 255.56 184.795 255.253 186.053C255.233 186.131 255.164 186.184 255.085 186.184H255.084Z",
    fill: "url(#paint106_linear_376_4207)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M253.292 191.988C253.272 191.988 253.252 191.984 253.23 191.977C253.141 191.944 253.098 191.844 253.132 191.755C253.552 190.649 254.538 188.063 254.538 182.557V168.861C254.538 165.341 253.525 156.506 244.133 150.506C234.564 144.389 224.87 146.431 220.653 148.599C216 150.994 212.727 154.523 210.923 159.086C210.889 159.174 210.79 159.219 210.701 159.183C210.612 159.148 210.57 159.048 210.605 158.961C212.44 154.315 215.767 150.728 220.497 148.293C224.779 146.09 234.617 144.016 244.318 150.215C253.852 156.306 254.88 165.283 254.88 168.859V182.555C254.88 188.124 253.879 190.753 253.452 191.875C253.427 191.944 253.361 191.986 253.292 191.986V191.988Z",
    fill: "url(#paint107_linear_376_4207)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M251.112 196.525C251.085 196.525 251.057 196.52 251.034 196.505C250.95 196.461 250.917 196.358 250.961 196.274C253.245 191.887 253.205 187.963 253.185 186.077C253.185 185.922 253.183 185.782 253.183 185.656V172.144C253.183 164.3 249.834 158.114 242.946 153.232C236.243 148.483 226.727 147.41 219.803 150.62C213.527 153.53 211.054 158.946 211.029 159.001C210.991 159.086 210.889 159.126 210.803 159.086C210.716 159.048 210.678 158.946 210.716 158.86C210.741 158.804 213.267 153.272 219.657 150.309C226.687 147.05 236.343 148.137 243.142 152.953C250.128 157.902 253.523 164.181 253.523 172.146V186.075C253.547 187.989 253.587 191.973 251.263 196.434C251.232 196.492 251.172 196.527 251.11 196.527L251.112 196.525Z",
    fill: "url(#paint108_linear_376_4207)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M248.999 199.921C248.959 199.921 248.921 199.909 248.888 199.881C248.818 199.819 248.808 199.712 248.868 199.639C248.894 199.61 251.371 196.6 251.371 189.296V175.225C251.371 167.222 248.09 160.912 241.34 155.939C235.698 151.782 228.775 150.16 222.351 151.487C217.386 152.512 213.3 155.218 211.142 158.911C211.093 158.993 210.987 159.019 210.907 158.973C210.825 158.926 210.798 158.82 210.845 158.738C213.053 154.962 217.223 152.196 222.281 151.15C228.8 149.805 235.823 151.447 241.544 155.663C248.388 160.705 251.714 167.104 251.714 175.223V189.294C251.714 196.74 249.236 199.736 249.13 199.859C249.096 199.899 249.048 199.919 248.999 199.919V199.921Z",
    fill: "url(#paint109_linear_376_4207)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M246.012 203.824C245.975 203.824 245.939 203.813 245.908 203.789C245.832 203.733 245.817 203.625 245.873 203.549C249.003 199.373 249.094 194.04 249.094 193.444V178.024C249.094 161.938 235.054 154.572 228.253 153.527C216.506 151.722 211.318 158.731 211.267 158.802C211.211 158.879 211.105 158.897 211.027 158.84C210.951 158.786 210.933 158.678 210.989 158.602C211.042 158.529 216.357 151.347 228.306 153.188C235.201 154.25 249.438 161.717 249.438 178.026V193.446C249.438 194.052 249.345 199.49 246.15 203.756C246.115 203.802 246.064 203.825 246.013 203.825L246.012 203.824Z",
    fill: "url(#paint110_linear_376_4207)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M243.062 207.032C243.024 207.032 242.985 207.02 242.953 206.994C242.878 206.934 242.869 206.827 242.929 206.752C245.275 203.884 246.464 199.774 246.464 194.537V180.708C246.464 166.902 234.893 157.759 227.076 155.927C220.772 154.448 215.935 155.3 211.398 158.687C211.321 158.746 211.214 158.729 211.158 158.653C211.101 158.576 211.118 158.469 211.192 158.412C215.816 154.96 220.741 154.091 227.154 155.592C235.081 157.449 246.808 166.716 246.808 180.708V194.537C246.808 199.854 245.591 204.037 243.195 206.969C243.16 207.011 243.111 207.032 243.062 207.032Z",
    fill: "url(#paint111_linear_376_4207)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M239.724 210.139C239.685 210.139 239.647 210.126 239.614 210.099C239.542 210.039 239.531 209.93 239.591 209.857C243.322 205.337 243.313 200.759 243.308 197.729V197.374V183.546C243.308 169.233 231.981 159.915 223.936 157.868C218.454 156.473 214.071 157.16 209.732 160.097C209.654 160.15 209.547 160.13 209.494 160.051C209.442 159.973 209.462 159.866 209.54 159.813C213.966 156.816 218.43 156.115 224.018 157.537C232.17 159.609 243.648 169.049 243.648 183.546V197.727C243.655 200.807 243.664 205.461 239.853 210.075C239.82 210.117 239.771 210.137 239.72 210.137L239.724 210.139Z",
    fill: "url(#paint112_linear_376_4207)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M235.734 213.329C235.694 213.329 235.654 213.315 235.621 213.287C235.55 213.226 235.543 213.116 235.605 213.045C239.818 208.181 239.8 203.695 239.787 200.725V200.242V186.439C239.787 171.01 228.235 161.923 220.952 159.82C214.217 157.875 209.81 160.05 207.785 161.517C207.708 161.572 207.601 161.556 207.547 161.479C207.49 161.403 207.508 161.295 207.585 161.239C209.661 159.733 214.169 157.504 221.048 159.489C228.426 161.621 240.131 170.822 240.131 186.439V200.725C240.145 203.746 240.165 208.311 235.867 213.271C235.834 213.309 235.785 213.329 235.737 213.329H235.734Z",
    fill: "url(#paint113_linear_376_4207)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M230.493 216.877C230.44 216.877 230.389 216.853 230.357 216.807C230.3 216.731 230.317 216.624 230.391 216.567C235.141 213.027 235.85 207.204 235.85 204.046V188.866C235.85 183.802 234.501 174.12 225.471 166.186C214.984 156.972 206.386 162.404 206.301 162.461C206.223 162.512 206.115 162.49 206.064 162.411C206.012 162.331 206.035 162.226 206.114 162.175C206.201 162.116 215.007 156.537 225.698 165.93C234.83 173.953 236.194 183.744 236.194 188.866V204.046C236.194 207.267 235.466 213.213 230.597 216.842C230.566 216.866 230.529 216.877 230.495 216.877H230.493Z",
    fill: "url(#paint114_linear_376_4207)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M226.227 219.353C226.176 219.353 226.125 219.329 226.091 219.286C226.033 219.209 226.047 219.102 226.122 219.045C231.532 214.901 231.532 208.74 231.532 206.422V191.244C231.532 179.499 226.002 172.026 221.363 167.825C213.104 160.344 206.334 162.639 204.457 163.52C204.374 163.56 204.27 163.524 204.228 163.438C204.188 163.353 204.225 163.251 204.31 163.211C206.237 162.307 213.177 159.951 221.59 167.572C226.28 171.82 231.87 179.374 231.87 191.246V206.424C231.87 208.79 231.87 215.072 226.327 219.318C226.296 219.342 226.258 219.355 226.224 219.355L226.227 219.353Z",
    fill: "url(#paint115_linear_376_4207)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M221.668 221.669C221.618 221.669 221.567 221.646 221.532 221.602C221.474 221.526 221.488 221.418 221.563 221.362C226.887 217.283 226.887 211.297 226.887 208.742V193.563C226.887 190.034 226.887 179.297 216.893 169.32C210.967 163.404 205.028 163.537 202.451 164.547C202.364 164.582 202.264 164.538 202.23 164.451C202.195 164.362 202.239 164.263 202.326 164.229C204.979 163.189 211.083 163.038 217.135 169.078C227.229 179.157 227.229 190.001 227.229 193.565V208.744C227.229 211.35 227.229 217.452 221.77 221.637C221.739 221.66 221.701 221.673 221.667 221.673L221.668 221.669Z",
    fill: "url(#paint116_linear_376_4207)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M216.884 223.792C216.833 223.792 216.784 223.771 216.75 223.727C216.691 223.652 216.704 223.545 216.777 223.485C221.403 219.81 221.937 214.256 221.937 210.399V195.221C221.937 189.728 220.621 179.177 211.802 170.26C206.765 165.166 202.191 165.21 199.916 165.689C199.82 165.711 199.733 165.649 199.713 165.556C199.693 165.463 199.753 165.372 199.846 165.352C202.191 164.859 206.894 164.809 212.045 170.017C220.952 179.022 222.281 189.673 222.281 195.22V210.397C222.281 214.327 221.732 219.987 216.99 223.752C216.959 223.778 216.92 223.789 216.882 223.789L216.884 223.792Z",
    fill: "url(#paint117_linear_376_4207)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M211.138 225.989C211.08 225.989 211.026 225.96 210.993 225.907C210.944 225.827 210.967 225.721 211.049 225.67C216.074 222.565 216.654 216.742 216.654 212.632V197.603C216.654 189.438 214.504 182.031 210.264 175.59C203.936 165.977 198.009 166.645 196.886 166.875C196.789 166.896 196.702 166.835 196.682 166.742C196.664 166.649 196.722 166.558 196.815 166.54C197.98 166.301 204.098 165.602 210.547 175.4C214.824 181.898 216.994 189.369 216.994 197.602V212.63C216.994 216.822 216.395 222.766 211.226 225.96C211.198 225.978 211.168 225.985 211.137 225.985L211.138 225.989Z",
    fill: "url(#paint118_linear_376_4207)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M205.794 227.735C205.736 227.735 205.681 227.706 205.649 227.653C205.6 227.573 205.623 227.467 205.705 227.416C211.049 224.113 211.049 217.363 211.049 214.118V199.089C211.049 190.941 209.044 183.48 205.089 176.914C199.81 168.149 194.913 167.88 193.527 168.006C193.433 168.011 193.349 167.944 193.342 167.851C193.333 167.756 193.403 167.672 193.496 167.663C194.916 167.53 199.999 167.8 205.383 176.735C209.371 183.354 211.393 190.875 211.393 199.088V214.116C211.393 217.423 211.393 224.303 205.885 227.706C205.858 227.724 205.827 227.731 205.796 227.731L205.794 227.735Z",
    fill: "url(#paint119_linear_376_4207)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M200.504 229.214C200.446 229.214 200.388 229.183 200.355 229.128C200.308 229.046 200.337 228.941 200.419 228.893C205.156 226.162 205.156 217.982 205.156 214.903V199.876C205.156 196.99 204.725 186.82 199.171 177.114C195.46 170.628 192.038 169.155 189.821 169.062C189.726 169.058 189.654 168.978 189.657 168.883C189.661 168.789 189.723 168.716 189.836 168.719C192.138 168.816 195.678 170.322 199.468 176.945C205.063 186.723 205.498 196.97 205.498 199.878V214.905C205.498 218.037 205.498 226.36 200.59 229.192C200.562 229.206 200.533 229.216 200.504 229.216V229.214Z",
    fill: "url(#paint120_linear_376_4207)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M194.616 230.598C194.554 230.598 194.494 230.565 194.463 230.506C194.42 230.423 194.453 230.319 194.536 230.275C199.024 227.926 199.024 219.572 199.024 216.826V201.797C199.024 193.26 197.313 185.461 193.94 178.618C191.27 173.201 188.343 170.154 185.695 170.043C185.6 170.039 185.528 169.959 185.531 169.865C185.535 169.77 185.599 169.701 185.71 169.701C188.488 169.819 191.519 172.931 194.247 178.467C197.644 185.359 199.366 193.208 199.366 201.799V216.827C199.366 219.624 199.366 228.134 194.696 230.581C194.671 230.594 194.643 230.601 194.616 230.601V230.598Z",
    fill: "url(#paint121_linear_376_4207)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M188.717 231.736C188.654 231.736 188.59 231.699 188.563 231.638C188.523 231.552 188.561 231.45 188.646 231.41C192.631 229.556 192.631 221.267 192.631 217.727V203.154C192.631 183.997 185.271 171.181 181.422 170.868C181.327 170.861 181.256 170.777 181.265 170.684C181.273 170.59 181.356 170.519 181.451 170.528C185.984 170.895 192.974 185.074 192.974 203.156V217.729C192.974 221.334 192.974 229.777 188.792 231.723C188.768 231.734 188.743 231.74 188.719 231.74L188.717 231.736Z",
    fill: "url(#paint122_linear_376_4207)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M182.567 232.677C182.479 232.677 182.405 232.611 182.396 232.522C182.387 232.429 182.454 232.346 182.549 232.335C182.599 232.327 185.845 231.736 185.845 219.047V203.98C185.845 190.784 181.747 173.388 176.655 171.578C176.566 171.547 176.519 171.449 176.551 171.36C176.582 171.27 176.679 171.221 176.77 171.256C181.987 173.111 186.187 190.676 186.187 203.982V219.049C186.187 232.182 182.729 232.664 182.581 232.679C182.576 232.679 182.57 232.679 182.565 232.679L182.567 232.677Z",
    fill: "url(#paint123_linear_376_4207)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M176.259 233.411C176.197 233.411 176.139 233.378 176.108 233.32C176.064 233.236 176.095 233.133 176.179 233.089C178.865 231.661 178.865 222.995 178.865 219.295V204.68C178.865 184.005 173.657 172.263 171.929 172.137C171.835 172.13 171.764 172.048 171.771 171.953C171.778 171.859 171.846 171.784 171.955 171.795C174.17 171.957 179.207 184.549 179.207 204.682V219.297C179.207 225.514 178.866 232.051 176.339 233.395C176.313 233.407 176.286 233.415 176.259 233.415V233.411Z",
    fill: "url(#paint124_linear_376_4207)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M170.02 233.919C169.982 233.919 169.944 233.906 169.913 233.881C169.838 233.821 169.827 233.713 169.887 233.639C171.404 231.756 171.531 226.388 171.531 220.582V205.578C171.531 182.945 168.214 172.904 166.832 172.531C166.741 172.505 166.687 172.412 166.712 172.319C166.738 172.228 166.829 172.174 166.923 172.199C168.596 172.653 171.875 183.214 171.875 205.578V220.582C171.875 226.677 171.746 231.881 170.156 233.855C170.124 233.897 170.073 233.919 170.024 233.919H170.02Z",
    fill: "url(#paint125_linear_376_4207)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M163.077 234.243C163.059 234.243 163.043 234.241 163.024 234.236C162.935 234.207 162.884 234.11 162.914 234.019C163.928 230.872 164.119 226.868 164.119 220.582V205.577C164.119 179.242 162.312 173.81 161.533 172.698C161.479 172.62 161.497 172.514 161.575 172.459C161.653 172.407 161.759 172.425 161.813 172.501C163.495 174.91 164.461 186.965 164.461 205.579V220.584C164.461 226.906 164.266 230.936 163.239 234.126C163.215 234.199 163.148 234.245 163.075 234.245L163.077 234.243Z",
    fill: "url(#paint126_linear_376_4207)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M156.772 234.339C156.678 234.339 156.602 234.263 156.602 234.168V172.669C156.602 172.574 156.678 172.498 156.772 172.498C156.867 172.498 156.943 172.574 156.943 172.669V234.168C156.943 234.263 156.867 234.339 156.772 234.339Z",
    fill: "url(#paint127_linear_376_4207)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M156.773 172.842C134.828 172.842 116.133 168.645 105.481 161.326C105.402 161.273 105.382 161.166 105.437 161.088C105.492 161.009 105.599 160.991 105.675 161.044C116.269 168.324 134.894 172.5 156.773 172.5C181.269 172.5 201.608 167.239 211.178 158.425C211.247 158.362 211.356 158.367 211.42 158.436C211.483 158.506 211.48 158.615 211.409 158.679C201.777 167.548 181.352 172.844 156.771 172.844L156.773 172.842Z",
    fill: "url(#paint128_linear_376_4207)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M105.579 161.355C105.546 161.355 105.512 161.346 105.483 161.324C104.248 160.478 103.121 159.584 102.128 158.668C102.059 158.604 102.053 158.495 102.117 158.425C102.18 158.356 102.29 158.353 102.359 158.414C103.341 159.319 104.457 160.203 105.677 161.04C105.755 161.093 105.775 161.201 105.721 161.279C105.688 161.328 105.634 161.353 105.579 161.353V161.355Z",
    fill: "url(#paint129_linear_376_4207)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M178.003 23.4805C178.159 21.5521 178.048 19.651 177.703 17.8191C177.703 17.8209 177.703 17.8228 177.705 17.8246V17.8173C177.292 15.6503 176.55 13.5799 175.523 11.6697V11.6642C175.523 11.6642 175.519 11.6606 175.517 11.6606C174.513 9.79958 173.237 8.09333 171.731 6.60195C171.731 6.60195 171.735 6.60378 171.737 6.6056L171.731 6.60195C170.285 5.17249 168.629 3.94152 166.8 2.96366L166.792 2.9582C166.792 2.9582 166.789 2.9582 166.787 2.95637C165.423 2.22981 163.963 1.64346 162.423 1.22099C162.426 1.22099 162.428 1.22099 162.432 1.22099H162.417C161.226 0.887754 159.744 0.614609 158.339 0.512635H158.333C158.333 0.512635 158.331 0.512635 158.329 0.512635C157.137 0.423407 155.955 0.436154 154.793 0.545412C154.793 0.545412 154.796 0.545412 154.798 0.545412H154.789C153.585 0.660133 152.401 0.875007 151.252 1.18457H151.238C151.238 1.18457 151.238 1.18821 151.236 1.18821C150.261 1.45225 149.31 1.78367 148.39 2.17882C148.39 2.17882 148.39 2.17882 148.39 2.177L148.372 2.1861C147.49 2.56669 146.635 3.00554 145.815 3.49902L145.801 3.50631C144.926 4.03439 144.089 4.62438 143.297 5.27083C143.297 5.27083 143.297 5.27083 143.295 5.27083L143.282 5.28357C142.475 5.94458 141.715 6.66569 141.009 7.44142L140.994 7.45417C140.994 7.45417 140.998 7.45053 141 7.45053C140.291 8.23172 139.638 9.06573 139.049 9.95254C139.047 9.95436 139.045 9.95618 139.043 9.958L139.036 9.97075C138.341 11.0142 137.734 12.1268 137.229 13.2995V13.3031C137.229 13.3031 137.229 13.3013 137.229 13.2995C136.681 14.5669 136.25 15.9053 135.952 17.3038C135.952 17.3074 135.95 17.3111 135.948 17.3129V17.3238C135.659 18.6021 135.456 20.4777 135.474 21.8926V21.9036C135.474 21.9036 135.474 21.8981 135.474 21.8963C135.483 23.9048 135.776 25.8678 136.321 27.7398C136.325 27.7561 136.327 27.7671 136.327 27.7671L136.33 27.7725C137.149 30.5677 138.531 33.1553 140.367 35.3805C140.382 35.3988 140.391 35.4115 140.391 35.4115L140.387 35.406C142.969 38.5254 146.446 40.9236 150.518 42.1709C150.523 42.1709 150.527 42.1746 150.532 42.1764L150.523 42.1728C152.863 42.9066 155.756 43.2562 158.282 43.0632H158.286C159.65 42.9667 160.986 42.7391 162.281 42.3913C162.283 42.3913 162.284 42.3913 162.286 42.3913L162.301 42.3858C163.386 42.0926 164.441 41.7157 165.459 41.2605L165.472 41.2568C165.472 41.2568 165.47 41.2568 165.469 41.2568C166.39 40.8435 167.281 40.3645 168.132 39.8274L168.142 39.8201C169.08 39.2264 169.971 38.56 170.807 37.8279L170.818 37.8188C170.818 37.8188 170.818 37.8188 170.818 37.817C171.704 37.0395 172.528 36.1872 173.279 35.2676C173.279 35.2676 173.279 35.2695 173.279 35.2713L173.286 35.2622C174.124 34.2333 174.872 33.1207 175.512 31.9335L175.519 31.9225C175.519 31.9225 175.519 31.9207 175.519 31.9189C176.126 30.7917 176.637 29.5971 177.041 28.3461C177.041 28.348 177.041 28.3498 177.041 28.3534V28.3443C177.512 26.8784 177.868 25.2032 178.005 23.4933V23.4878C178.005 23.4878 178.005 23.486 178.005 23.4842L178.003 23.4805Z",
    fill: "#141332"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M156.782 43.2834C155.517 43.2834 154.235 43.1705 152.945 42.9374C141.298 40.8251 133.539 29.617 135.649 17.9519C136.671 12.3014 139.829 7.38847 144.542 4.11619C149.254 0.843906 154.956 -0.392532 160.599 0.629032C172.246 2.74136 180.005 13.9494 177.896 25.6145C176.019 35.9886 166.958 43.2834 156.782 43.2834ZM156.728 0.623569C152.467 0.623569 148.312 1.91646 144.737 4.39844C140.1 7.61791 136.992 12.4526 135.987 18.0138C133.91 29.4914 141.546 40.521 153.009 42.6005C158.561 43.6094 164.172 42.3893 168.809 39.1698C173.446 35.9504 176.554 31.1157 177.559 25.5563C179.636 14.0787 172 3.0491 160.537 0.969553C159.266 0.73829 157.991 0.62539 156.728 0.62539V0.623569Z",
    fill: "url(#paint130_linear_376_4207)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M148.659 9.49186C148.578 9.49186 148.498 9.48093 148.425 9.45544C148.268 9.40445 148.15 9.30248 148.087 9.16226C147.932 8.8272 148.138 8.37196 148.545 8.1498C149.058 7.87119 149.452 8.03872 149.618 8.33008C149.689 8.4539 149.703 8.60869 149.658 8.76711C149.592 8.99837 149.41 9.21689 149.17 9.35164C149.005 9.44451 148.825 9.49186 148.658 9.49186H148.659ZM148.71 8.45026C148.441 8.59776 148.33 8.86908 148.399 9.0184C148.423 9.07121 148.468 9.10763 148.532 9.12948C148.661 9.17137 148.843 9.14223 149.007 9.05118C149.167 8.96195 149.29 8.8181 149.33 8.67424C149.35 8.60504 149.347 8.54313 149.321 8.49943C149.221 8.32097 148.981 8.30276 148.71 8.45026Z",
    fill: "url(#paint131_linear_376_4207)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M162.028 42.5768C158.328 42.5768 154.131 33.4374 151.616 25.4433C148.807 16.5078 148.688 8.8288 148.688 8.75232C148.688 8.66673 148.748 8.59389 148.834 8.58115C148.918 8.57022 148.999 8.61757 149.025 8.69951C149.058 8.80513 152.405 19.3321 156.879 28.1129C161.399 36.9828 164.261 41.3422 165.432 41.0873C165.527 41.0654 165.616 41.1237 165.638 41.2165C165.658 41.3094 165.6 41.4005 165.509 41.4223C164.571 41.639 162.718 40.3225 156.575 28.2695C152.971 21.195 150.096 12.9934 149.087 9.98693C149.239 12.5035 149.81 18.5564 151.945 25.3413C154.684 34.0456 158.939 42.6424 162.265 42.2199C162.367 42.2035 162.445 42.2745 162.456 42.3692C162.468 42.4639 162.401 42.5495 162.307 42.5604C162.216 42.5714 162.123 42.5786 162.03 42.5786L162.028 42.5768Z",
    fill: "url(#paint132_linear_376_4207)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M168.129 39.9967C168.062 39.9967 167.998 39.9567 167.971 39.8893C167.261 38.1576 162.25 30.1471 160.11 26.7273L159.935 26.4487C157.82 23.069 148.806 8.98563 148.715 8.8436C148.67 8.77258 148.683 8.67789 148.748 8.62144C148.812 8.56499 148.908 8.56499 148.972 8.62144C149.039 8.67971 155.769 14.5742 160.684 20.6052C165.961 27.0824 172.029 35.3351 170.975 37.8826C170.938 37.97 170.836 38.0119 170.751 37.9755C170.664 37.939 170.622 37.8389 170.658 37.7515C171.431 35.8868 167.794 29.8758 160.419 20.8238C156.609 16.1493 151.703 11.555 149.681 9.71766C151.83 13.0774 158.451 23.4314 160.224 26.2666L160.399 26.5452C162.725 30.2637 167.567 37.9991 168.287 39.7582C168.323 39.8456 168.282 39.9457 168.192 39.9822C168.171 39.9913 168.149 39.9949 168.127 39.9949L168.129 39.9967Z",
    fill: "url(#paint133_linear_376_4207)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M173.275 35.4407C173.253 35.4407 173.231 35.437 173.211 35.4279C173.124 35.3933 173.08 35.2932 173.115 35.2039C174.382 32.0227 170.673 26.1209 162.672 18.5894C156.467 12.7477 148.857 8.94192 148.781 8.90368C148.704 8.86544 148.666 8.77622 148.695 8.69427C148.723 8.61233 148.81 8.56134 148.892 8.58319C148.979 8.6014 157.7 10.4734 164.668 15.8106C173.044 22.2277 176.543 27.3556 175.682 31.9499C175.664 32.0427 175.581 32.1046 175.482 32.0864C175.39 32.0682 175.328 31.979 175.346 31.8861C176.181 27.432 172.722 22.4116 164.461 16.0819C159.191 12.0449 152.905 10.0072 150.186 9.26059C152.621 10.599 158.169 13.8786 162.906 18.3381C168.645 23.7391 175.128 31.0722 173.433 35.3314C173.406 35.3988 173.342 35.4388 173.273 35.4388L173.275 35.4407Z",
    fill: "url(#paint134_linear_376_4207)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M177.037 28.521C177.028 28.521 177.017 28.521 177.007 28.5192C176.914 28.5028 176.852 28.4136 176.868 28.3207C178.223 20.6435 167.684 14.0553 161.921 11.6443C155.337 8.88918 148.925 8.92378 148.861 8.92378C148.754 8.91832 148.698 8.85823 148.688 8.769C148.679 8.68159 148.739 8.59965 148.827 8.58326C148.916 8.56687 157.939 6.88612 166.553 10.5918C176.81 15.004 178.098 21.0733 178.174 23.4788C178.176 23.5735 178.103 23.6536 178.009 23.6554C177.921 23.6518 177.836 23.5844 177.832 23.4897C177.758 21.1498 176.496 15.2425 166.418 10.9068C160.277 8.26641 153.927 8.39024 150.83 8.67431C153.262 8.86915 157.62 9.47189 162.056 11.3275C167.905 13.7748 178.599 20.4888 177.208 28.3808C177.194 28.4646 177.121 28.5229 177.039 28.5229L177.037 28.521Z",
    fill: "url(#paint135_linear_376_4207)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M177.705 17.9974C177.636 17.9974 177.57 17.9537 177.545 17.8845C174.836 10.515 168.373 8.69587 162.529 7.57052C156.484 6.4051 148.99 8.8889 148.916 8.91439C148.834 8.94353 148.739 8.90164 148.705 8.8197C148.669 8.73776 148.703 8.64125 148.781 8.59936C148.852 8.56112 156.013 4.80993 162.068 5.34165C167.887 5.84788 171.704 6.51982 175.656 11.5603C175.714 11.6349 175.701 11.7424 175.627 11.8006C175.552 11.8589 175.443 11.8461 175.387 11.7715C171.521 6.84031 167.766 6.18112 162.039 5.68399C157.979 5.33255 153.402 6.93682 150.878 8.00755C153.569 7.33925 158.417 6.42877 162.594 7.23364C168.531 8.37721 175.096 10.2291 177.867 17.7661C177.9 17.8553 177.854 17.9537 177.765 17.9865C177.745 17.9937 177.725 17.9974 177.707 17.9974H177.705Z",
    fill: "url(#paint136_linear_376_4207)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M148.86 8.92359C148.813 8.92359 148.767 8.90538 148.733 8.86714C148.672 8.80158 148.672 8.70143 148.733 8.63588C148.816 8.54483 157.144 -0.465327 166.844 2.79603C166.933 2.82698 166.982 2.9235 166.953 3.01272C166.922 3.10377 166.826 3.15294 166.737 3.12016C159.663 0.743796 153.322 5.05039 150.515 7.43586C152.077 6.4671 154.506 5.13962 157.083 4.41305C160.759 3.37692 166.291 2.46279 171.837 6.46528C171.914 6.51991 171.932 6.62735 171.875 6.70383C171.819 6.78031 171.714 6.79852 171.635 6.74207C166.211 2.82698 160.785 3.72472 157.175 4.74264C152.889 5.94995 149.003 8.85621 148.963 8.88535C148.933 8.90902 148.896 8.91995 148.86 8.91995V8.92359Z",
    fill: "url(#paint137_linear_376_4207)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M148.859 8.92344C148.832 8.92344 148.805 8.91798 148.778 8.90341C148.699 8.86153 148.667 8.76502 148.701 8.68307C148.736 8.60477 152.205 0.752756 158.319 0.343038C158.433 0.333933 158.495 0.408593 158.501 0.503283C158.508 0.597974 158.435 0.679917 158.341 0.68538C154.269 0.958525 151.396 4.68423 149.992 6.99686C152.087 4.54948 156.606 0.330291 162.448 1.05322C162.543 1.06414 162.608 1.14973 162.598 1.24442C162.587 1.33911 162.498 1.4083 162.407 1.39374C154.502 0.428623 149.056 8.75956 149.001 8.84514C148.969 8.89613 148.914 8.92344 148.858 8.92344H148.859Z",
    fill: "url(#paint138_linear_376_4207)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M148.859 8.92373C148.859 8.92373 148.845 8.92373 148.838 8.92373C148.752 8.91281 148.687 8.83815 148.689 8.75074C148.69 8.50491 148.785 2.7033 151.138 1.04804C151.214 0.993414 151.323 1.01162 151.376 1.08993C151.431 1.16823 151.412 1.27384 151.334 1.32847C149.829 2.38828 149.307 5.41837 149.125 7.26483C149.881 5.04325 151.665 1.0007 154.762 0.379748C154.858 0.359717 154.946 0.42163 154.964 0.514499C154.982 0.607369 154.922 0.698417 154.829 0.716627C150.829 1.51967 149.043 8.72161 149.027 8.79445C149.009 8.87275 148.938 8.92555 148.859 8.92555V8.92373Z",
    fill: "url(#paint139_linear_376_4207)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M148.859 8.92359C148.799 8.92359 148.743 8.89264 148.712 8.83801L145.653 3.59362C145.606 3.51168 145.633 3.40606 145.715 3.35871C145.795 3.30955 145.9 3.33868 145.949 3.42063L148.417 7.65256C148.082 6.12294 147.641 3.45705 148.233 2.10953C148.272 2.02212 148.375 1.98388 148.459 2.02212C148.546 2.06036 148.584 2.16234 148.546 2.24792C147.751 4.05068 149.012 8.65955 149.024 8.7069C149.048 8.79066 149.004 8.87807 148.926 8.91085C148.904 8.91995 148.881 8.92359 148.859 8.92359Z",
    fill: "url(#paint140_linear_376_4207)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M148.859 8.92337C148.832 8.92337 148.803 8.91609 148.778 8.90334C148.721 8.87239 143.157 5.87325 141.106 7.5886C141.033 7.6487 140.926 7.63959 140.864 7.56675C140.804 7.49391 140.813 7.38648 140.886 7.32456C142.531 5.94609 146.012 7.22987 147.814 8.04749C146.383 6.82198 144.208 5.17946 143.344 5.43622C143.251 5.46353 143.157 5.41255 143.131 5.3215C143.104 5.23045 143.155 5.13576 143.246 5.10844C144.708 4.66231 148.545 8.22048 148.978 8.62656C149.041 8.68483 149.05 8.78316 148.999 8.85236C148.967 8.89788 148.914 8.92337 148.861 8.92337H148.859Z",
    fill: "url(#paint141_linear_376_4207)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M137.227 13.4761C137.202 13.4761 137.174 13.4707 137.151 13.4579C137.067 13.416 137.033 13.3122 137.074 13.2285C138.995 9.40809 144.348 8.68517 147.139 8.57591C144.885 8.21536 140.959 7.9586 139.175 10.0691C139.113 10.1401 139.006 10.1492 138.933 10.0891C138.86 10.0272 138.851 9.91978 138.913 9.84694C141.619 6.64386 148.609 8.50489 148.903 8.58501C148.989 8.60868 149.041 8.69245 149.027 8.77803C149.012 8.86544 148.95 8.931 148.847 8.92189C148.758 8.91643 139.866 8.43205 137.378 13.3814C137.347 13.4415 137.287 13.4761 137.225 13.4761H137.227Z",
    fill: "url(#paint142_linear_376_4207)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M135.474 22.0784C135.474 22.0784 135.458 22.0784 135.451 22.0784C135.356 22.0656 135.293 21.9782 135.305 21.8853C136.34 14.525 142.997 10.843 146.567 9.37711C143.352 10.1838 137.747 12.2907 136.115 17.3712C136.085 17.4622 135.989 17.5132 135.898 17.4822C135.807 17.4531 135.758 17.3566 135.787 17.2655C138.177 9.83417 148.736 8.59591 148.842 8.58317C148.938 8.57042 149.013 8.63415 149.029 8.72338C149.045 8.81261 148.991 8.89819 148.903 8.92005C148.783 8.951 137.029 12.0776 135.644 21.9327C135.631 22.0183 135.558 22.0802 135.474 22.0802V22.0784Z",
    fill: "url(#paint143_linear_376_4207)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M140.391 35.5827C140.34 35.5827 140.291 35.5609 140.256 35.5172C140.229 35.4826 137.556 32.041 138.078 26.7838C138.934 18.147 144.43 12.3035 147.188 9.87613C134.13 17.5989 136.469 27.6215 136.494 27.7271C136.518 27.8181 136.461 27.9128 136.37 27.9347C136.274 27.9583 136.185 27.9019 136.161 27.8108C136.134 27.6998 133.517 16.5554 148.779 8.59963C148.857 8.55775 148.957 8.58506 149.005 8.66336C149.05 8.74166 149.028 8.84182 148.954 8.8928C148.859 8.95654 139.547 15.4283 138.416 26.8166C137.909 31.9299 140.496 35.2695 140.524 35.3023C140.582 35.377 140.569 35.4844 140.496 35.5427C140.465 35.5682 140.427 35.5791 140.389 35.5791L140.391 35.5827Z",
    fill: "url(#paint144_linear_376_4207)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M150.532 42.3474C150.512 42.3474 150.494 42.3438 150.474 42.3365C143.818 39.9201 141.711 29.7518 143.52 21.3189C144.622 16.1765 146.362 12.5345 147.522 10.5133C145.931 12.4599 143.415 16.0271 141.947 20.5905C139.938 26.8328 139.707 35.6062 145.666 39.7853C145.744 39.84 145.762 39.9474 145.708 40.0239C145.653 40.1022 145.546 40.1204 145.469 40.0658C139.358 35.7792 139.578 26.8382 141.622 20.4849C143.902 13.3922 148.694 8.6759 148.743 8.62855C148.806 8.56482 148.91 8.563 148.975 8.62491C149.043 8.685 149.052 8.78697 148.995 8.85799C148.963 8.9017 145.606 13.2338 143.855 21.3917C142.076 29.6808 144.109 39.6615 150.59 42.0142C150.679 42.047 150.725 42.1453 150.694 42.2345C150.668 42.3037 150.603 42.3474 150.532 42.3474Z",
    fill: "url(#paint145_linear_376_4207)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M158.284 43.2323C158.284 43.2323 158.266 43.2323 158.257 43.2305C154.034 42.5422 150.216 35.7828 148.53 26.0151C147.315 18.977 147.952 13.0334 148.39 10.3092C147.404 12.8932 145.637 18.6638 145.99 26.0369C146.519 37.0848 150.889 41.9613 154.469 42.7807C154.562 42.8026 154.618 42.8936 154.598 42.9865C154.576 43.0794 154.484 43.1376 154.393 43.1158C150.696 42.2709 146.186 37.2942 145.646 26.0551C145.159 15.8978 148.668 8.74684 148.705 8.67582C148.745 8.59752 148.836 8.5611 148.917 8.59205C148.999 8.62301 149.046 8.7086 149.025 8.79418C149.006 8.86884 147.215 16.3876 148.866 25.9586C150.501 35.4331 154.298 42.2399 158.311 42.8936C158.406 42.9082 158.468 42.9974 158.453 43.0903C158.439 43.1741 158.366 43.2342 158.284 43.2342V43.2323Z",
    fill: "url(#paint146_linear_376_4207)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M199.742 104.146L199.753 104.16C199.753 104.147 199.742 104.126 199.742 104.111C199.726 103.162 199.684 102.21 199.604 101.254L199.613 101.316C199.499 100.105 199.284 98.2948 198.848 96.1224L198.815 95.8984C198.821 95.9258 198.813 95.9421 198.815 95.9676C198.621 95.1354 198.36 93.7916 197.842 92.1946L197.893 92.3184C197.873 92.2547 197.85 92.2 197.826 92.1418C197.422 90.8307 196.966 89.5505 196.451 88.3068C196.438 88.274 196.435 88.2449 196.42 88.2121L196.38 88.1429C195.931 87.0722 195.449 86.0251 194.924 85.009L194.9 84.9489V84.9562C193.953 83.1207 192.258 80.3965 190.516 78.1567L190.558 78.2277C190.379 78.0001 190.203 77.7707 190.021 77.5485C189.985 77.503 189.95 77.452 189.914 77.412L189.854 77.3537C189.503 76.9294 189.15 76.5088 188.783 76.099C188.783 76.099 188.772 76.0863 188.767 76.0808C187.166 74.2981 185.421 72.6702 183.564 71.1897L183.479 71.1059C183.504 71.1296 183.53 71.1587 183.555 71.1824C180.376 68.6495 176.858 66.579 173.106 65.033C173.061 65.0112 173.021 64.9875 172.974 64.9656C172.95 64.9584 172.925 64.9565 172.901 64.9492C172.87 64.9365 172.841 64.9256 172.81 64.9128C172.619 64.82 172.519 64.7835 172.519 64.7835L172.53 64.7999C167.813 62.9334 162.752 61.8846 157.561 61.7899C157.561 61.7899 157.552 61.7899 157.546 61.7899C157.446 61.7899 157.346 61.7935 157.246 61.7899C157.212 61.788 157.175 61.7826 157.139 61.7808L157.086 61.7899C152.556 61.7971 147.452 62.4636 142.464 64.25V64.2445C138.027 65.8015 132.848 68.6841 129.101 71.8981C128.89 72.051 128.784 72.153 128.784 72.153L128.735 72.2113C128.062 72.7922 127.406 73.3858 126.773 74.0049V73.9995C126.773 73.9995 126.76 74.0158 126.755 74.0231C124.122 76.5998 121.843 79.497 119.961 82.629C119.949 82.6472 119.934 82.6636 119.921 82.6818L119.954 82.6436C118.832 84.5137 117.854 86.4676 117.025 88.4871L117.019 88.4689C117.01 88.4998 117.003 88.5326 116.994 88.5636C116.357 90.1241 115.804 91.7193 115.352 93.3509C115.324 93.4237 115.314 93.4674 115.314 93.4674L115.31 93.4948C114.843 95.2046 114.488 96.951 114.233 98.7191C114.172 99.0706 114.146 99.2672 114.146 99.2672L114.157 99.2618C113.99 100.54 113.882 101.831 113.832 103.131L113.815 103.237C113.815 103.21 113.828 103.195 113.83 103.17C113.73 105.755 113.864 108.374 114.248 111C114.252 111.034 114.248 111.074 114.253 111.111L114.284 111.231C114.288 111.26 114.293 111.287 114.297 111.317C114.284 111.297 114.279 111.282 114.279 111.282L114.313 111.415C114.666 113.58 115.323 116.708 116.434 119.635L116.465 119.759C116.477 119.782 116.494 119.806 116.505 119.83C116.515 119.862 116.528 119.893 116.541 119.926L116.574 120.054C116.572 120.039 116.574 120.021 116.57 120.006C117.527 122.556 118.703 124.97 120.076 127.228L120.018 127.152C120.038 127.188 120.06 127.21 120.081 127.237C120.263 127.536 120.449 127.835 120.638 128.128L120.618 128.113C121.745 129.872 123.493 132.196 125.462 134.301L125.535 134.396C125.557 134.416 125.58 134.428 125.602 134.448C127.522 136.471 129.624 138.292 131.879 139.895C131.903 139.917 131.927 139.94 131.952 139.96L131.947 139.944C132.641 140.436 133.347 140.913 134.069 141.363L134.041 141.352C134.058 141.361 134.078 141.372 134.096 141.381C138.031 143.828 142.353 145.629 146.89 146.709L146.956 146.736C146.956 146.736 147.045 146.76 147.207 146.787C147.423 146.836 147.638 146.887 147.854 146.933C147.865 146.937 147.876 146.942 147.887 146.946V146.94C152.436 147.907 157.188 148.142 161.974 147.552L161.932 147.565C161.932 147.565 162.049 147.559 162.26 147.523C163.045 147.43 164.585 147.153 166.342 146.791V146.785C168.577 146.321 172.63 144.977 175.35 143.639L175.408 143.622C176.743 142.943 178.402 142.087 180.469 140.754C180.496 140.74 180.522 140.727 180.549 140.711L180.545 140.7C183.335 138.848 185.863 136.688 188.108 134.288L188.077 134.334C188.077 134.334 188.188 134.232 188.376 134.011C189.554 132.729 190.643 131.373 191.654 129.963C191.687 129.927 191.721 129.892 191.754 129.856L191.747 129.832C193.183 127.813 194.449 125.679 195.52 123.446L195.546 123.41C195.624 123.26 195.689 123.095 195.757 122.933C197.302 119.597 198.43 116.06 199.086 112.404L199.117 112.274C199.121 112.249 199.122 112.225 199.124 112.2C199.144 112.089 199.166 111.979 199.184 111.868C199.193 111.825 199.202 111.783 199.212 111.739L199.206 111.719C199.61 109.239 199.792 106.706 199.75 104.149L199.742 104.146Z",
    fill: "#141332"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M156.711 148.055C149.528 148.055 142.422 146.241 135.956 142.674C125.86 137.105 118.534 127.933 115.326 116.847C112.118 105.761 113.415 94.0884 118.975 83.9784C124.536 73.8683 133.694 66.5317 144.766 63.3195C167.622 56.6911 191.597 69.915 198.218 92.7991C204.839 115.683 191.632 139.696 168.78 146.327C164.801 147.481 160.743 148.053 156.711 148.053V148.055ZM156.755 61.9537C152.82 61.9537 148.826 62.5018 144.861 63.6509C133.877 66.8376 124.791 74.116 119.275 84.1459C113.76 94.1758 112.475 105.755 115.657 116.754C118.839 127.753 126.107 136.85 136.123 142.375C146.137 147.898 157.7 149.185 168.685 146.001C191.357 139.423 204.457 115.601 197.889 92.8993C192.47 74.167 175.321 61.9556 156.755 61.9556V61.9537Z",
    fill: "url(#paint147_linear_376_4207)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M193.11 109.625C191.414 109.625 189.57 108.634 187.802 106.749C185.649 104.453 183.856 101.092 182.754 97.2876C180.47 89.3955 181.923 82.0133 185.991 80.8333C187.984 80.2561 190.281 81.2194 192.463 83.5448C194.616 85.841 196.409 89.2025 197.509 93.0065C198.609 96.8105 198.889 100.611 198.294 103.705C197.693 106.839 196.265 108.884 194.272 109.461C193.894 109.57 193.507 109.625 193.108 109.625H193.11ZM187.153 81.0118C186.787 81.0118 186.431 81.061 186.086 81.1611C182.2 82.2883 180.854 89.4793 183.083 97.1911C184.169 100.944 185.933 104.256 188.051 106.514C190.139 108.742 192.314 109.672 194.178 109.131C196.04 108.59 197.382 106.642 197.958 103.639C198.542 100.598 198.265 96.856 197.18 93.1012C196.094 89.3482 194.33 86.0358 192.212 83.7778C190.51 81.9642 188.753 81.01 187.153 81.01V81.0118Z",
    fill: "url(#paint148_linear_376_4207)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M163.495 147.281C152.206 147.281 139.801 132.691 133.677 111.524C127.061 88.6585 130.815 68.2618 142.405 64.079C142.494 64.0481 142.592 64.0936 142.625 64.1828C142.658 64.272 142.611 64.3704 142.522 64.4032C131.104 68.524 127.443 88.7422 134.006 111.431C137.183 122.408 142.236 132.049 148.239 138.577C154.219 145.081 160.635 147.938 166.297 146.62C166.396 146.598 166.483 146.656 166.503 146.747C166.525 146.84 166.466 146.931 166.376 146.953C165.426 147.173 164.464 147.281 163.495 147.281Z",
    fill: "url(#paint149_linear_376_4207)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M147.883 147.113C147.864 147.113 147.844 147.109 147.826 147.104C138.167 143.722 128.529 130.571 123.843 114.378C119.162 98.1982 120.284 81.9278 126.636 73.8883C126.696 73.8136 126.803 73.8027 126.878 73.861C126.953 73.9192 126.963 74.0285 126.905 74.1031C120.621 82.059 119.523 98.2055 124.172 114.285C128.827 130.375 138.378 143.435 147.937 146.782C148.026 146.813 148.073 146.911 148.043 147C148.017 147.071 147.952 147.115 147.881 147.115L147.883 147.113Z",
    fill: "url(#paint150_linear_376_4207)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M131.948 140.131C131.908 140.131 131.868 140.117 131.837 140.089C125.7 134.774 120.54 126.053 117.679 116.167C114.824 106.301 114.524 96.1878 116.856 88.4177C116.883 88.3266 116.976 88.2738 117.068 88.303C117.159 88.3303 117.21 88.425 117.183 88.516C114.87 96.2242 115.172 106.269 118.008 116.073C120.851 125.897 125.973 134.557 132.061 139.831C132.132 139.893 132.141 140.002 132.079 140.073C132.045 140.113 131.997 140.133 131.95 140.133L131.948 140.131Z",
    fill: "url(#paint151_linear_376_4207)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M174.911 142.351C170.202 142.351 165.072 139.614 160.146 134.399C154.092 127.991 149.063 118.598 145.982 107.953C139.614 85.9394 143.68 65.3479 155.049 62.0501C155.907 61.8006 156.726 61.6568 157.551 61.6094C157.638 61.5985 157.727 61.6768 157.733 61.7715C157.738 61.8662 157.666 61.9481 157.571 61.9536C156.771 62.0009 155.976 62.1393 155.143 62.3815C143.958 65.6265 139.996 86.0286 146.311 107.86C149.377 118.455 154.378 127.796 160.395 134.166C166.383 140.505 172.651 143.136 178.052 141.568C178.987 141.297 179.705 140.995 180.456 140.558C180.538 140.508 180.643 140.537 180.69 140.619C180.738 140.701 180.71 140.807 180.629 140.854C179.852 141.306 179.11 141.619 178.148 141.898C177.099 142.202 176.017 142.353 174.911 142.353V142.351Z",
    fill: "url(#paint152_linear_376_4207)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M183.963 133.849C179.876 133.849 175.43 131.495 171.165 127.006C165.919 121.485 161.568 113.387 158.911 104.204C155.076 90.9454 155.483 77.5322 159.951 70.0371C161.759 67.0033 164.09 65.1605 166.879 64.5559C168.898 64.1189 170.965 64.199 173.024 64.7945C173.115 64.82 173.167 64.9165 173.14 65.0075C173.115 65.0986 173.02 65.1514 172.927 65.1241C170.924 64.545 168.914 64.4685 166.95 64.891C164.257 65.4737 162.001 67.2637 160.244 70.2119C155.823 77.6305 155.429 90.9345 159.24 104.107C161.881 113.238 166.205 121.286 171.413 126.768C176.593 132.219 182.02 134.476 186.702 133.119C188.439 132.615 190.048 131.508 191.621 129.734C191.683 129.663 191.792 129.657 191.863 129.719C191.934 129.783 191.939 129.89 191.877 129.962C190.261 131.784 188.599 132.926 186.798 133.449C185.878 133.716 184.931 133.847 183.963 133.847V133.849Z",
    fill: "url(#paint153_linear_376_4207)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M190.097 122.676C183.211 122.676 175.23 113.413 171.507 100.549C167.414 86.3949 170.004 73.1619 177.283 71.0514C180.812 70.0262 184.942 71.7744 188.908 75.9735C188.973 76.0427 188.97 76.152 188.901 76.2157C188.831 76.2813 188.722 76.2776 188.659 76.2084C184.785 72.1094 180.781 70.3941 177.377 71.381C170.28 73.4387 167.796 86.4823 171.837 100.455C175.879 114.425 184.938 124.116 192.037 122.06C195.523 121.048 197.945 117.466 199.038 111.701C199.056 111.608 199.147 111.548 199.238 111.564C199.331 111.583 199.393 111.672 199.375 111.765C198.256 117.666 195.75 121.339 192.132 122.39C191.468 122.583 190.786 122.676 190.095 122.676H190.097Z",
    fill: "url(#paint154_linear_376_4207)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M192.454 95.6435C192.297 95.6435 192.135 95.5616 191.986 95.405C191.826 95.2356 191.695 94.9916 191.615 94.7167C191.435 94.0921 191.575 93.5403 191.943 93.4347C192.304 93.3291 192.723 93.7188 192.903 94.3434C193.083 94.968 192.943 95.5197 192.575 95.6271C192.535 95.6381 192.494 95.6454 192.452 95.6454L192.454 95.6435ZM192.064 93.7607C192.055 93.7607 192.046 93.7607 192.037 93.7643C191.91 93.8007 191.81 94.154 191.944 94.622C192.008 94.8423 192.114 95.0408 192.235 95.1701C192.326 95.2648 192.419 95.3158 192.481 95.2975C192.608 95.2611 192.708 94.9079 192.574 94.4399C192.446 94.0028 192.201 93.7607 192.064 93.7607Z",
    fill: "url(#paint155_linear_376_4207)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M127.416 135.406C126.709 135.406 126.052 135.115 125.414 134.519C125.345 134.455 125.341 134.346 125.407 134.277C125.472 134.208 125.58 134.204 125.649 134.268C126.267 134.845 126.903 135.102 127.571 135.056C129.831 134.903 132.822 131.52 138.649 124.375C139.44 123.404 140.261 122.381 141.116 121.317C148.166 112.538 157.82 100.516 170.242 94.1192C181.445 88.3504 188.991 92.0797 191.479 93.7313C189.442 91.1182 182.467 83.7251 169.836 85.3621C153.896 87.4271 140.138 101.274 133.355 109.344C129.487 113.946 126.471 118.806 124.267 122.355C122.045 125.935 121.024 127.532 120.308 127.532C120.303 127.532 120.297 127.532 120.293 127.532C120.17 127.528 119.993 127.472 119.863 127.228C119.819 127.144 119.85 127.04 119.933 126.995C120.017 126.951 120.121 126.98 120.166 127.064C120.237 127.197 120.288 127.184 120.312 127.188C120.864 127.188 122.308 124.864 123.978 122.175C126.185 118.617 129.211 113.744 133.093 109.122C139.909 101.013 153.738 87.1012 169.793 85.0198C185.235 83.0204 192.339 94.3213 192.408 94.4342C192.454 94.507 192.437 94.6017 192.372 94.6564C192.306 94.711 192.21 94.7092 192.146 94.6509C192.068 94.5781 183.983 87.4253 170.398 94.4215C158.04 100.786 148.412 112.775 141.382 121.528C140.527 122.594 139.703 123.617 138.912 124.589C132.888 131.977 129.997 135.233 127.593 135.397C127.533 135.401 127.473 135.402 127.414 135.402L127.416 135.406Z",
    fill: "url(#paint156_linear_376_4207)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M116.572 120.223C116.49 120.223 116.417 120.163 116.403 120.079C115.612 115.242 121.229 103.191 130.555 93.6312C139.795 84.1621 155.344 74.9863 171.262 77.6285C184.069 79.7554 189.901 89.1734 191.743 92.9228C190.708 88.9659 186.913 78.7375 174.495 72.9122C156.399 64.421 138.482 75.3414 131.617 80.4273C120.743 88.4869 113.569 103.262 114.42 111.087C114.431 111.182 114.362 111.265 114.27 111.276C114.164 111.284 114.091 111.218 114.08 111.123C113.217 103.189 120.125 88.5179 131.414 80.1505C138.327 75.0263 156.379 64.0331 174.641 72.599C190.368 79.9776 192.414 94.3577 192.434 94.5016C192.445 94.589 192.389 94.671 192.303 94.691C192.221 94.7092 192.13 94.6637 192.103 94.5817C192.054 94.4415 187.004 80.5894 171.206 77.9654C155.418 75.3432 139.978 84.4608 130.801 93.8679C121.812 103.08 115.964 115.273 116.743 120.021C116.757 120.114 116.693 120.203 116.601 120.217C116.592 120.217 116.583 120.219 116.573 120.219L116.572 120.223Z",
    fill: "url(#paint157_linear_376_4207)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M114.144 99.4383C114.144 99.4383 114.13 99.4383 114.123 99.4383C114.028 99.4256 113.962 99.34 113.975 99.2471C113.988 99.1433 115.397 88.742 123.344 79.954C133.603 68.6093 144.694 65.1021 152.189 64.1571C160.316 63.1337 166.096 64.8199 166.155 64.8381C180.233 68.5529 186.63 76.4267 189.518 82.3777C191.732 86.9428 192.276 91.1092 192.403 93.1742C192.707 91.4552 192.987 88.1902 191.867 84.2824C190.336 78.9488 185.804 71.2952 172.905 65.1185C172.819 65.0785 172.783 64.9747 172.823 64.8891C172.865 64.8035 172.968 64.7689 173.052 64.809C186.081 71.0476 190.658 78.8013 192.203 84.2096C193.882 90.0822 192.443 94.5417 192.429 94.5873C192.402 94.6692 192.318 94.7184 192.236 94.702C192.152 94.6874 192.092 94.6109 192.096 94.5253C192.098 94.4689 192.302 88.8894 189.203 82.5142C186.346 76.6343 180.011 68.8515 166.064 65.1713C166.002 65.1531 160.274 63.4851 152.218 64.503C144.785 65.4427 133.785 68.9262 123.602 80.187C115.73 88.8913 114.333 99.1907 114.319 99.2926C114.308 99.38 114.233 99.442 114.148 99.442L114.144 99.4383Z",
    fill: "url(#paint158_linear_376_4207)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M192.263 94.7002C192.203 94.7002 192.145 94.6674 192.114 94.6128C192.076 94.5454 192.089 94.4598 192.145 94.4052C192.207 94.3451 198.21 88.2922 190.383 78.2569C190.325 78.1822 190.338 78.0748 190.412 78.0165C190.487 77.9582 190.594 77.971 190.654 78.0456C197.429 86.7316 194.042 92.546 192.785 94.1812C193.709 93.8462 195.518 93.0231 196.282 91.5081C196.76 90.5575 196.755 89.4686 196.268 88.274C196.231 88.1866 196.273 88.0864 196.362 88.05C196.451 88.0136 196.549 88.0555 196.586 88.1447C197.113 89.4358 197.115 90.6212 196.588 91.6647C195.477 93.8698 192.438 94.662 192.309 94.6947C192.294 94.6984 192.282 94.7002 192.267 94.7002H192.263Z",
    fill: "url(#paint159_linear_376_4207)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M199.616 101.485C199.527 101.485 199.453 101.416 199.445 101.326C199.305 99.5037 198.816 98.0342 197.991 96.9379C196.212 96.9143 192.645 94.9385 192.181 94.6781C192.117 94.6417 192.083 94.5707 192.095 94.4979C192.108 94.4268 192.166 94.3704 192.237 94.3595C192.352 94.3412 195.061 93.9479 197.238 95.6778C197.58 95.9492 197.889 96.2569 198.162 96.6011C198.305 96.5865 198.425 96.5483 198.513 96.4863C198.563 96.4499 198.722 96.337 198.647 95.9273C198.631 95.8344 198.693 95.7452 198.785 95.727C198.88 95.7088 198.967 95.7725 198.985 95.8654C199.06 96.2806 198.969 96.5829 198.713 96.7649C198.623 96.8287 198.514 96.8742 198.387 96.9015C199.178 98.0305 199.647 99.5019 199.785 101.299C199.793 101.394 199.722 101.476 199.627 101.483C199.622 101.483 199.618 101.483 199.615 101.483L199.616 101.485ZM192.861 94.6581C194.172 95.3555 196.414 96.4244 197.703 96.5865C197.496 96.3534 197.272 96.1404 197.029 95.9473C195.549 94.7692 193.754 94.6326 192.861 94.6563V94.6581Z",
    fill: "url(#paint160_linear_376_4207)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M192.263 94.7003C192.237 94.7003 192.21 94.6949 192.186 94.6821C192.112 94.6457 192.075 94.562 192.097 94.4837L194.736 84.8999C194.761 84.8088 194.852 84.7542 194.947 84.7797C195.037 84.8052 195.092 84.8999 195.067 84.9909L192.643 93.7971C193.555 92.7373 195.478 90.747 196.858 90.9819C197.412 91.0784 197.816 91.51 198.06 92.2657C198.089 92.3568 198.04 92.4533 197.949 92.4824C197.86 92.5134 197.761 92.4624 197.732 92.3713C197.529 91.7395 197.225 91.3953 196.8 91.3206C195.452 91.0894 193.166 93.6333 192.399 94.6348C192.366 94.6785 192.315 94.7022 192.263 94.7022V94.7003Z",
    fill: "url(#paint161_linear_376_4207)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M192.263 94.7004C192.181 94.7004 192.11 94.644 192.096 94.562C192.058 94.3727 188.241 75.6385 183.366 71.2281C183.295 71.1644 183.289 71.057 183.353 70.986C183.417 70.9168 183.526 70.9113 183.595 70.9732C187.763 74.7444 191.056 88.2433 192.094 92.9159C192.065 89.1119 191.787 79.7266 189.786 77.5214C189.723 77.4522 189.728 77.343 189.799 77.2792C189.87 77.2155 189.977 77.2209 190.041 77.2901C192.643 80.1618 192.445 93.9466 192.434 94.5311C192.434 94.6185 192.365 94.6913 192.278 94.6986C192.272 94.6986 192.267 94.6986 192.263 94.6986V94.7004Z",
    fill: "url(#paint162_linear_376_4207)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M148.128 147.03C147.402 147.03 146.973 146.917 146.904 146.897C146.813 146.871 146.76 146.776 146.786 146.685C146.811 146.594 146.902 146.54 146.997 146.567C147.061 146.585 153.887 148.332 162.137 136.164C165.614 131.036 168.931 125.515 172.135 120.176C176.593 112.752 180.805 105.739 184.447 101.587C188.755 96.6761 190.728 95.3104 191.81 94.6129C190.079 94.3471 182.889 94.0248 172.935 104.169C166.141 111.091 160.695 118.306 155.891 124.672C152.534 129.118 149.364 133.319 146.328 136.588C139.181 144.285 135.615 142.386 134.093 141.574L133.953 141.499C133.87 141.456 133.837 141.352 133.881 141.268C133.924 141.184 134.03 141.151 134.112 141.195L134.253 141.27C135.705 142.044 139.107 143.859 146.077 136.353C149.101 133.097 152.265 128.904 155.616 124.464C160.428 118.091 165.879 110.865 172.689 103.927C184.273 92.1255 191.986 94.2651 192.31 94.3617C192.374 94.3799 192.421 94.4345 192.43 94.5019C192.441 94.5674 192.41 94.6348 192.354 94.6694L192.155 94.7969C191.124 95.456 189.202 96.6852 184.705 101.811C181.083 105.941 176.879 112.939 172.429 120.351C169.222 125.693 165.903 131.218 162.421 136.353C155.993 145.833 150.488 147.026 148.126 147.026L148.128 147.03Z",
    fill: "url(#paint163_linear_376_4207)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M161.928 147.73C161.837 147.73 161.761 147.659 161.757 147.567C161.752 147.472 161.826 147.392 161.919 147.388C161.995 147.384 169.711 146.834 176.475 131.262C179.51 124.273 182.531 116.931 185.195 110.452C188.528 102.348 191.159 95.9475 192.117 94.4361C192.159 94.3706 192.241 94.3414 192.316 94.3651C192.39 94.3888 192.439 94.4616 192.434 94.5399C192.432 94.5909 192.09 99.808 190.315 108.512C189.995 110.084 189.684 111.774 189.355 113.565C187.24 125.092 184.607 139.436 175.477 143.773C175.392 143.813 175.29 143.777 175.248 143.691C175.208 143.606 175.244 143.504 175.33 143.462C184.304 139.201 186.917 124.952 189.019 113.503C189.348 111.712 189.659 110.018 189.979 108.445C191.354 101.705 191.866 97.0656 192.028 95.3047C190.866 97.5664 188.466 103.406 185.515 110.584C182.849 117.065 179.829 124.409 176.792 131.4C169.931 147.197 162.259 147.718 161.935 147.732C161.934 147.732 161.93 147.732 161.928 147.732V147.73Z",
    fill: "url(#paint164_linear_376_4207)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M188.073 134.499C188.028 134.499 187.98 134.481 187.946 134.443C187.882 134.374 187.888 134.264 187.957 134.201C187.99 134.171 191.203 131.136 192.288 122.095C193.376 113.03 193.107 106.269 192.092 94.5417C192.085 94.4543 192.143 94.376 192.228 94.3578C192.316 94.3377 192.399 94.3905 192.425 94.4743C192.706 95.372 199.282 116.552 195.691 123.481C195.647 123.564 195.543 123.599 195.46 123.553C195.376 123.51 195.343 123.406 195.387 123.322C198.347 117.608 194.063 101.368 192.576 96.186C193.472 106.924 193.667 113.48 192.628 122.133C191.526 131.32 188.324 134.328 188.188 134.452C188.155 134.481 188.113 134.496 188.073 134.496V134.499Z",
    fill: "url(#paint165_linear_376_4207)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M198.999 112.906C198.999 112.906 198.984 112.906 198.975 112.906C198.88 112.893 198.815 112.806 198.828 112.713C199.473 108.031 192.187 94.7455 192.112 94.6126C192.078 94.5507 192.085 94.4724 192.132 94.4177C192.178 94.3631 192.254 94.3431 192.32 94.3667C192.409 94.3977 201.083 97.6918 199.282 112.291C199.275 112.345 199.244 112.391 199.201 112.416C199.193 112.535 199.182 112.649 199.168 112.759C199.155 112.844 199.082 112.906 198.997 112.906H198.999ZM192.662 94.9003C193.796 97.0071 198.317 105.637 199.097 110.721C199.961 99.5547 194.333 95.7689 192.662 94.9003Z",
    fill: "url(#paint166_linear_376_4207)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M199.756 104.327H199.753C199.658 104.326 199.584 104.247 199.585 104.153C199.609 103.126 195.145 97.9031 192.137 94.6436C192.074 94.5744 192.077 94.4651 192.146 94.4014C192.217 94.3376 192.326 94.3413 192.388 94.4105C193.163 95.2499 199.962 102.663 199.927 104.16C199.925 104.253 199.849 104.327 199.756 104.327Z",
    fill: "url(#paint167_linear_376_4207)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M156.995 147.825C151.838 147.825 147.505 146.998 147.443 146.987C147.35 146.969 147.29 146.88 147.309 146.785C147.327 146.692 147.412 146.632 147.509 146.649C147.596 146.667 156.232 148.311 163.605 146.929C170.868 145.567 175.005 143.413 178.314 141.501C181.524 139.645 184.817 137.484 189.767 131.478C196.851 122.881 198.342 112.633 197.377 105.91C196.668 100.973 194.335 97.366 193.036 95.6834C196.882 103.932 196.742 112.617 192.618 122.186C188.334 132.126 178.538 139.114 170.732 141.628C162.531 144.271 153.366 146.461 139.502 141.82C125.98 137.291 120.523 128.29 120.469 128.199C120.42 128.117 120.447 128.011 120.529 127.964C120.609 127.915 120.714 127.942 120.763 128.024C120.816 128.113 126.215 137.008 139.609 141.494C153.371 146.102 162.478 143.925 170.626 141.301C178.358 138.809 188.061 131.89 192.303 122.049C196.595 112.094 196.531 103.109 192.114 94.5836C192.076 94.5089 192.096 94.416 192.165 94.3651C192.233 94.3159 192.327 94.3214 192.389 94.3833C192.433 94.427 196.704 98.8119 197.717 105.859C198.695 112.655 197.19 123.013 190.032 131.695C185.048 137.744 181.728 139.926 178.487 141.796C175.154 143.722 170.984 145.893 163.669 147.264C161.47 147.676 159.161 147.823 156.997 147.823L156.995 147.825Z",
    fill: "url(#paint168_linear_376_4207)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M153.339 137.109C150.859 137.109 148.455 136.943 146.184 136.642C133.104 134.909 120.261 127.683 116.309 119.835C116.267 119.749 116.3 119.647 116.386 119.604C116.469 119.562 116.573 119.595 116.616 119.68C120.521 127.436 133.253 134.581 146.229 136.302C159.387 138.048 177.11 135.202 187.366 121.987C195.31 111.75 193.588 100.372 192.572 96.206C192.895 102.714 191.001 108.762 187.042 113.791C182.958 118.979 176.901 122.863 169.529 125.023C154.37 129.462 134.746 124.651 125.652 119.815C115.849 114.601 114.189 111.489 114.123 111.36C114.08 111.276 114.114 111.173 114.198 111.131C114.283 111.089 114.385 111.122 114.429 111.205C114.445 111.236 116.14 114.368 125.814 119.513C134.857 124.32 154.367 129.105 169.434 124.695C184.703 120.223 193.599 108.379 192.097 94.5253C192.088 94.4397 192.144 94.3596 192.23 94.3395C192.313 94.3195 192.401 94.3669 192.43 94.4488C192.483 94.5963 197.656 109.293 187.638 122.2C179.066 133.246 165.339 137.11 153.343 137.112L153.339 137.109Z",
    fill: "url(#paint169_linear_376_4207)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M161.759 115.155C153.385 115.155 143.915 113.241 133.168 109.397C129.084 107.937 125.565 106.509 122.737 105.36C118.082 103.47 115.004 102.223 114.189 102.767C114.102 102.825 113.985 102.938 113.983 103.239C113.983 103.333 113.907 103.41 113.813 103.41C113.718 103.41 113.642 103.332 113.642 103.237C113.643 102.893 113.763 102.64 113.998 102.483C114.965 101.837 117.771 102.975 122.866 105.043C125.692 106.19 129.207 107.618 133.282 109.075C151.083 115.439 165.354 116.495 176.917 112.307C189.039 107.915 191.504 98.3421 191.983 95.3849C187.146 103.76 175.919 106.167 158.591 102.541C153.378 101.451 144.678 98.5989 137.003 96.0841C130.131 93.8316 123.639 91.7047 121.197 91.3623C116.267 90.6722 115.507 93.3927 115.476 93.5074C115.453 93.5985 115.358 93.6531 115.267 93.6313C115.176 93.6076 115.12 93.5147 115.144 93.4237C115.151 93.3927 115.995 90.2843 121.243 91.0218C123.714 91.3678 129.92 93.4018 137.106 95.7563C144.773 98.2693 153.465 101.117 158.658 102.204C176.357 105.908 187.611 103.292 192.108 94.427C192.144 94.3542 192.226 94.3196 192.304 94.3396C192.383 94.3615 192.435 94.4343 192.432 94.5144C192.424 94.6419 191.606 107.349 177.03 112.631C172.387 114.314 167.31 115.157 161.753 115.157L161.759 115.155Z",
    fill: "url(#paint170_linear_376_4207)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M183.313 96.7198C180.001 96.7198 175.699 96.1553 170.269 94.4363C159.431 91.0074 154.633 88.9789 149.992 87.0159C147.928 86.1436 145.791 85.2404 143.142 84.2189C135.572 81.3017 124.136 76.8968 120.061 82.7748C120.008 82.8531 119.901 82.8714 119.823 82.8186C119.744 82.7639 119.726 82.6565 119.779 82.58C124.005 76.4798 135.596 80.9448 143.264 83.8984C145.919 84.9218 148.057 85.825 150.125 86.699C154.971 88.7476 159.55 90.6833 170.371 94.1086C183.513 98.2658 190.075 95.5289 191.734 94.6239C190.677 94.4691 187.884 93.8482 181.831 91.3553C177.263 89.4742 171.277 86.1619 164.939 82.6528C158.353 79.0073 151.541 75.2379 145.546 72.6302C133.986 67.6007 128.951 72.2242 128.902 72.2697C128.833 72.3352 128.726 72.3334 128.66 72.2642C128.595 72.195 128.597 72.0876 128.666 72.022C128.717 71.9729 133.899 67.1892 145.682 72.3152C151.694 74.9301 158.511 78.7032 165.105 82.3524C171.433 85.8541 177.412 89.1628 181.96 91.0366C189.879 94.2979 192.214 94.3289 192.259 94.3289C192.352 94.3234 192.401 94.3744 192.425 94.4454C192.448 94.5165 192.425 94.5929 192.365 94.6385C192.194 94.7641 189.464 96.7162 183.309 96.7162L183.313 96.7198Z",
    fill: "url(#paint171_linear_376_4207)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M192.264 94.6747C192.226 94.6747 192.19 94.662 192.157 94.6383C192.033 94.54 179.563 84.6721 171.125 77.9327L170.831 77.696C162.517 71.0549 149.953 61.0178 141.682 64.738C141.594 64.7781 141.494 64.738 141.454 64.6524C141.416 64.5668 141.454 64.4648 141.542 64.4248C150.003 60.6208 162.664 70.7344 171.045 77.4265L171.342 77.6632C178.426 83.321 188.353 91.1857 191.428 93.6186C189.306 90.6668 182.57 81.5346 174.444 72.8741C166.274 64.1644 161.615 62.2068 157.131 61.9446C157.036 61.9392 156.963 61.859 156.969 61.7625C156.974 61.6678 157.058 61.5877 157.151 61.6005C161.717 61.8663 166.447 63.8457 174.693 72.6374C184.525 83.1207 192.328 94.2905 192.406 94.4016C192.455 94.4708 192.444 94.5673 192.383 94.6255C192.35 94.6565 192.308 94.6729 192.266 94.6729L192.264 94.6747Z",
    fill: "url(#paint172_linear_376_4207)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M192.274 94.7237C192.206 94.7237 192.141 94.6836 192.115 94.6162C189.681 88.5888 183.222 76.0332 179.288 71.0438C175.335 66.027 172.489 64.949 172.462 64.9381C172.373 64.9053 172.327 64.807 172.36 64.7177C172.391 64.6285 172.489 64.5848 172.578 64.614C172.697 64.6577 175.533 65.7247 179.558 70.8289C183.782 76.188 190.295 89.1916 192.432 94.4851C192.468 94.5725 192.425 94.6727 192.337 94.7091C192.317 94.7182 192.294 94.7219 192.274 94.7219V94.7237Z",
    fill: "url(#paint173_linear_376_4207)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M292.333 190.951C304.096 190.951 313.631 181.403 313.631 169.624C313.631 157.845 304.096 148.297 292.333 148.297C280.571 148.297 271.036 157.845 271.036 169.624C271.036 181.403 280.571 190.951 292.333 190.951Z",
    fill: "#27E6D6"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9301 190.951C33.6922 190.951 43.2273 181.403 43.2273 169.624C43.2273 157.845 33.6922 148.297 21.9301 148.297C10.1679 148.297 0.632812 157.845 0.632812 169.624C0.632812 181.403 10.1679 190.951 21.9301 190.951Z",
    fill: "#27E6D6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_376_4207",
    x1: 110.382,
    y1: 195.665,
    x2: 191.901,
    y2: 205.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_376_4207",
    x1: 143.957,
    y1: 226.691,
    x2: 194.096,
    y2: 232.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_376_4207",
    x1: 159.209,
    y1: 238.812,
    x2: 196.381,
    y2: 243.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_376_4207",
    x1: 133.367,
    y1: 214.83,
    x2: 190.657,
    y2: 221.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_376_4207",
    x1: 122.742,
    y1: 206.365,
    x2: 185.603,
    y2: 214.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_376_4207",
    x1: 114.965,
    y1: 199.401,
    x2: 179.385,
    y2: 207.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_376_4207",
    x1: 111.687,
    y1: 196.199,
    x2: 172.561,
    y2: 203.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_376_4207",
    x1: 112.052,
    y1: 196.412,
    x2: 165.252,
    y2: 203.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_376_4207",
    x1: 114.874,
    y1: 198.802,
    x2: 157.835,
    y2: 204.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_376_4207",
    x1: 119.318,
    y1: 202.996,
    x2: 150.221,
    y2: 206.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_376_4207",
    x1: 125.534,
    y1: 208.768,
    x2: 142.844,
    y2: 210.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_376_4207",
    x1: 133.696,
    y1: 292.266,
    x2: 174.258,
    y2: 297.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_376_4207",
    x1: 143.29,
    y1: 293.705,
    x2: 174.019,
    y2: 300.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_376_4207",
    x1: 148.991,
    y1: 292.562,
    x2: 172.786,
    y2: 298.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_376_4207",
    x1: 138.407,
    y1: 295.646,
    x2: 173.304,
    y2: 303.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_376_4207",
    x1: 135.527,
    y1: 298.549,
    x2: 171.987,
    y2: 305.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_376_4207",
    x1: 133.954,
    y1: 302.116,
    x2: 170.112,
    y2: 308.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_376_4207",
    x1: 134.24,
    y1: 306.053,
    x2: 167.708,
    y2: 311.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_376_4207",
    x1: 135.74,
    y1: 310.177,
    x2: 164.797,
    y2: 314.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_376_4207",
    x1: 137.999,
    y1: 314.49,
    x2: 161.483,
    y2: 318.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_376_4207",
    x1: 141.063,
    y1: 318.797,
    x2: 157.994,
    y2: 321.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_376_4207",
    x1: 144.81,
    y1: 322.943,
    x2: 154.365,
    y2: 324.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_376_4207",
    x1: 149.203,
    y1: 326.777,
    x2: 150.786,
    y2: 327.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_376_4207",
    x1: 149.115,
    y1: 295.753,
    x2: 169.963,
    y2: 297.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_376_4207",
    x1: 149.333,
    y1: 293.104,
    x2: 164.654,
    y2: 293.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_376_4207",
    x1: 146.93,
    y1: 292.333,
    x2: 158.391,
    y2: 292.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_376_4207",
    x1: 141.272,
    y1: 292.982,
    x2: 150.719,
    y2: 293.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_376_4207",
    x1: 136.488,
    y1: 298.114,
    x2: 149.193,
    y2: 298.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_376_4207",
    x1: 134.811,
    y1: 309.21,
    x2: 148.965,
    y2: 310.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_376_4207",
    x1: 135.745,
    y1: 319.963,
    x2: 148.541,
    y2: 322.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_376_4207",
    x1: 139.436,
    y1: 326.758,
    x2: 148.027,
    y2: 330.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_376_4207",
    x1: 144.454,
    y1: 327.325,
    x2: 149.758,
    y2: 327.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_376_4207",
    x1: 149.345,
    y1: 327.322,
    x2: 153.114,
    y2: 327.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_376_4207",
    x1: 149.54,
    y1: 327.321,
    x2: 159.308,
    y2: 328.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_376_4207",
    x1: 149.235,
    y1: 327.323,
    x2: 165.263,
    y2: 332.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_376_4207",
    x1: 148.91,
    y1: 320.038,
    x2: 172.97,
    y2: 327.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_376_4207",
    x1: 148.874,
    y1: 307.836,
    x2: 175.229,
    y2: 312.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_376_4207",
    x1: 148.944,
    y1: 300.824,
    x2: 173.908,
    y2: 303.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_376_4207",
    x1: 50.1161,
    y1: 104.911,
    x2: 233.687,
    y2: 140.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_376_4207",
    x1: 124.755,
    y1: 166.434,
    x2: 134.803,
    y2: 188.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_376_4207",
    x1: 156.582,
    y1: 104.911,
    x2: 156.91,
    y2: 104.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_376_4207",
    x1: 150.77,
    y1: 104.987,
    x2: 152.598,
    y2: 104.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_376_4207",
    x1: 144.266,
    y1: 105.263,
    x2: 148.296,
    y2: 105.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_376_4207",
    x1: 137.769,
    y1: 105.75,
    x2: 144.079,
    y2: 105.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_376_4207",
    x1: 129.336,
    y1: 106.717,
    x2: 139.707,
    y2: 106.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_376_4207",
    x1: 123.882,
    y1: 107.569,
    x2: 135.958,
    y2: 107.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_376_4207",
    x1: 118.455,
    y1: 108.598,
    x2: 132.389,
    y2: 109.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_376_4207",
    x1: 113.017,
    y1: 109.842,
    x2: 128.939,
    y2: 110.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_376_4207",
    x1: 107.888,
    y1: 111.217,
    x2: 125.656,
    y2: 111.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_376_4207",
    x1: 102.434,
    y1: 112.889,
    x2: 122.441,
    y2: 113.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_376_4207",
    x1: 97.4709,
    y1: 114.598,
    x2: 119.44,
    y2: 115.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_376_4207",
    x1: 92.9499,
    y1: 116.384,
    x2: 116.612,
    y2: 117.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_376_4207",
    x1: 88.3797,
    y1: 118.302,
    x2: 113.934,
    y2: 120.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_376_4207",
    x1: 84.1731,
    y1: 120.244,
    x2: 111.451,
    y2: 122.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_376_4207",
    x1: 80.0395,
    y1: 122.356,
    x2: 109.123,
    y2: 124.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_376_4207",
    x1: 76.1784,
    y1: 124.459,
    x2: 106.995,
    y2: 127.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_376_4207",
    x1: 72.297,
    y1: 126.683,
    x2: 105.019,
    y2: 130.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_376_4207",
    x1: 68.6192,
    y1: 129.037,
    x2: 103.217,
    y2: 133.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_376_4207",
    x1: 64.8985,
    y1: 131.367,
    x2: 101.486,
    y2: 137.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_376_4207",
    x1: 60.5038,
    y1: 133.805,
    x2: 99.7337,
    y2: 141.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_376_4207",
    x1: 57.8007,
    y1: 136.212,
    x2: 98.2736,
    y2: 145.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_376_4207",
    x1: 56.2592,
    y1: 138.717,
    x2: 96.9728,
    y2: 149.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_376_4207",
    x1: 55.8255,
    y1: 141.209,
    x2: 96.3155,
    y2: 152.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_376_4207",
    x1: 56.1247,
    y1: 143.772,
    x2: 98.7915,
    y2: 149.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_376_4207",
    x1: 56.9951,
    y1: 146.104,
    x2: 98.8533,
    y2: 151.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_376_4207",
    x1: 58.3981,
    y1: 148.44,
    x2: 98.9673,
    y2: 152.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_376_4207",
    x1: 60.2919,
    y1: 150.684,
    x2: 99.0865,
    y2: 154.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_376_4207",
    x1: 62.6564,
    y1: 152.884,
    x2: 99.2311,
    y2: 156.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_376_4207",
    x1: 65.3883,
    y1: 154.883,
    x2: 99.3711,
    y2: 157.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_376_4207",
    x1: 68.6008,
    y1: 156.829,
    x2: 101.178,
    y2: 159.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_376_4207",
    x1: 72.1808,
    y1: 158.701,
    x2: 103.292,
    y2: 161.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_376_4207",
    x1: 76.2119,
    y1: 160.477,
    x2: 105.015,
    y2: 162.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_376_4207",
    x1: 80.6226,
    y1: 162.141,
    x2: 107.064,
    y2: 163.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_376_4207",
    x1: 85.3647,
    y1: 163.67,
    x2: 109.303,
    y2: 164.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_376_4207",
    x1: 90.4045,
    y1: 165.139,
    x2: 112.011,
    y2: 166.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_376_4207",
    x1: 95.7749,
    y1: 166.429,
    x2: 115.234,
    y2: 167.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_376_4207",
    x1: 101.464,
    y1: 167.643,
    x2: 118.761,
    y2: 168.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_376_4207",
    x1: 107.442,
    y1: 168.714,
    x2: 122.631,
    y2: 169.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_376_4207",
    x1: 113.647,
    y1: 169.693,
    x2: 126.909,
    y2: 170.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_376_4207",
    x1: 120.122,
    y1: 170.523,
    x2: 131.347,
    y2: 170.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_376_4207",
    x1: 126.981,
    y1: 171.243,
    x2: 136.23,
    y2: 171.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_376_4207",
    x1: 134.046,
    y1: 171.79,
    x2: 141.177,
    y2: 171.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_376_4207",
    x1: 141.463,
    y1: 172.193,
    x2: 146.422,
    y2: 172.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_376_4207",
    x1: 148.958,
    y1: 172.428,
    x2: 151.796,
    y2: 172.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_376_4207",
    x1: 160.713,
    y1: 104.986,
    x2: 162.543,
    y2: 104.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_376_4207",
    x1: 164.749,
    y1: 105.262,
    x2: 168.779,
    y2: 105.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_376_4207",
    x1: 168.689,
    y1: 105.75,
    x2: 174.999,
    y2: 105.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_376_4207",
    x1: 172.568,
    y1: 106.719,
    x2: 182.938,
    y2: 106.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_376_4207",
    x1: 176.11,
    y1: 107.567,
    x2: 188.188,
    y2: 107.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_376_4207",
    x1: 179.453,
    y1: 108.6,
    x2: 193.385,
    y2: 109.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_376_4207",
    x1: 182.653,
    y1: 109.84,
    x2: 198.576,
    y2: 110.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_376_4207",
    x1: 185.699,
    y1: 111.218,
    x2: 203.468,
    y2: 111.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_376_4207",
    x1: 188.627,
    y1: 112.889,
    x2: 208.636,
    y2: 113.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_376_4207",
    x1: 191.372,
    y1: 114.596,
    x2: 213.342,
    y2: 115.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_376_4207",
    x1: 193.967,
    y1: 116.384,
    x2: 217.63,
    y2: 117.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_376_4207",
    x1: 196.377,
    y1: 118.303,
    x2: 221.955,
    y2: 120.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_376_4207",
    x1: 198.597,
    y1: 120.268,
    x2: 225.895,
    y2: 122.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_376_4207",
    x1: 200.636,
    y1: 122.355,
    x2: 229.733,
    y2: 124.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_376_4207",
    x1: 202.452,
    y1: 124.458,
    x2: 233.28,
    y2: 127.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_376_4207",
    x1: 204.041,
    y1: 126.683,
    x2: 236.781,
    y2: 130.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_376_4207",
    x1: 205.386,
    y1: 129.031,
    x2: 239.993,
    y2: 133.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_376_4207",
    x1: 206.521,
    y1: 131.363,
    x2: 243.119,
    y2: 137.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_376_4207",
    x1: 207.316,
    y1: 133.805,
    x2: 246.561,
    y2: 141.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_376_4207",
    x1: 207.885,
    y1: 136.212,
    x2: 248.371,
    y2: 145.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_376_4207",
    x1: 208.259,
    y1: 138.718,
    x2: 248.986,
    y2: 149.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_376_4207",
    x1: 208.604,
    y1: 141.206,
    x2: 249.107,
    y2: 152.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_376_4207",
    x1: 208.74,
    y1: 143.772,
    x2: 251.408,
    y2: 149.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_376_4207",
    x1: 208.938,
    y1: 146.103,
    x2: 250.802,
    y2: 151.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_376_4207",
    x1: 209.101,
    y1: 148.442,
    x2: 249.672,
    y2: 152.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_376_4207",
    x1: 209.295,
    y1: 150.691,
    x2: 248.094,
    y2: 154.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_376_4207",
    x1: 209.518,
    y1: 152.886,
    x2: 246.099,
    y2: 156.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_376_4207",
    x1: 209.791,
    y1: 154.886,
    x2: 243.766,
    y2: 157.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_376_4207",
    x1: 208.188,
    y1: 156.829,
    x2: 240.764,
    y2: 159.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_376_4207",
    x1: 206.295,
    y1: 158.704,
    x2: 237.407,
    y2: 161.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_376_4207",
    x1: 204.909,
    y1: 160.477,
    x2: 233.706,
    y2: 162.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_376_4207",
    x1: 203.179,
    y1: 162.148,
    x2: 229.61,
    y2: 163.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_376_4207",
    x1: 201.283,
    y1: 163.676,
    x2: 225.203,
    y2: 164.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_376_4207",
    x1: 198.866,
    y1: 165.14,
    x2: 220.466,
    y2: 166.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_376_4207",
    x1: 195.92,
    y1: 166.429,
    x2: 215.369,
    y2: 167.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_376_4207",
    x1: 192.666,
    y1: 167.643,
    x2: 209.957,
    y2: 168.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_376_4207",
    x1: 189.065,
    y1: 168.719,
    x2: 204.242,
    y2: 169.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_376_4207",
    x1: 185.014,
    y1: 169.701,
    x2: 198.273,
    y2: 170.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_376_4207",
    x1: 180.827,
    y1: 170.527,
    x2: 192.052,
    y2: 170.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_376_4207",
    x1: 176.181,
    y1: 171.245,
    x2: 185.429,
    y2: 171.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_376_4207",
    x1: 171.493,
    y1: 171.794,
    x2: 178.623,
    y2: 171.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_376_4207",
    x1: 166.513,
    y1: 172.193,
    x2: 171.47,
    y2: 172.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_376_4207",
    x1: 161.391,
    y1: 172.429,
    x2: 164.229,
    y2: 172.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_376_4207",
    x1: 156.589,
    y1: 172.498,
    x2: 156.917,
    y2: 172.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_376_4207",
    x1: 101.444,
    y1: 158.381,
    x2: 156.495,
    y2: 209.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_376_4207",
    x1: 101.935,
    y1: 158.371,
    x2: 105.381,
    y2: 158.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_376_4207",
    x1: 133.699,
    y1: 0.279782,
    x2: 174.246,
    y2: 5.36356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_376_4207",
    x1: 147.974,
    y1: 8.00732,
    x2: 149.525,
    y2: 8.22362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_376_4207",
    x1: 148.055,
    y1: 8.57959,
    x2: 164.253,
    y2: 9.59376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_376_4207",
    x1: 147.851,
    y1: 8.5791,
    x2: 169.172,
    y2: 10.4884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_376_4207",
    x1: 147.672,
    y1: 8.57812,
    x2: 173.277,
    y2: 11.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_376_4207",
    x1: 147.586,
    y1: 8.18896,
    x2: 174.961,
    y2: 13.1735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_376_4207",
    x1: 147.6,
    y1: 5.29004,
    x2: 173.445,
    y2: 12.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_376_4207",
    x1: 147.82,
    y1: 2.08496,
    x2: 166.666,
    y2: 10.1205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_376_4207",
    x1: 148.168,
    y1: 0.342284,
    x2: 160.98,
    y2: 2.95033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_376_4207",
    x1: 148.454,
    y1: 0.375976,
    x2: 154.425,
    y2: 0.926622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_376_4207",
    x1: 145.503,
    y1: 2.00732,
    x2: 148.752,
    y2: 2.20797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_376_4207",
    x1: 140.518,
    y1: 5.06982,
    x2: 147.865,
    y2: 7.03485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_376_4207",
    x1: 136.609,
    y1: 7.9751,
    x2: 147.295,
    y2: 10.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_376_4207",
    x1: 134.791,
    y1: 8.58154,
    x2: 147.747,
    y2: 10.2361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_376_4207",
    x1: 135.487,
    y1: 8.58008,
    x2: 147.962,
    y2: 9.33731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_376_4207",
    x1: 139.942,
    y1: 8.57959,
    x2: 149.877,
    y2: 8.96288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_376_4207",
    x1: 145.119,
    y1: 8.58105,
    x2: 157.423,
    y2: 9.1542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_376_4207",
    x1: 110.377,
    y1: 61.6089,
    x2: 191.895,
    y2: 71.8306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_376_4207",
    x1: 181.04,
    y1: 80.6699,
    x2: 197.189,
    y2: 81.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_376_4207",
    x1: 129.076,
    y1: 64.0693,
    x2: 163.583,
    y2: 65.9483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_376_4207",
    x1: 119.961,
    y1: 73.8237,
    x2: 145.879,
    y2: 75.0261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_376_4207",
    x1: 114.671,
    y1: 88.2949,
    x2: 130.778,
    y2: 88.9512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_376_4207",
    x1: 141.562,
    y1: 61.6084,
    x2: 177.638,
    y2: 63.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_376_4207",
    x1: 154.963,
    y1: 64.2788,
    x2: 188.993,
    y2: 66.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_376_4207",
    x1: 168.452,
    y1: 70.7651,
    x2: 196.899,
    y2: 72.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_376_4207",
    x1: 191.483,
    y1: 93.4175,
    x2: 192.859,
    y2: 93.5294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_376_4207",
    x1: 117.131,
    y1: 84.7827,
    x2: 184.571,
    y2: 96.9257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_376_4207",
    x1: 111.078,
    y1: 69.4365,
    x2: 183.576,
    y2: 83.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_376_4207",
    x1: 111.021,
    y1: 63.8276,
    x2: 181.372,
    y2: 83.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_376_4207",
    x1: 190.099,
    y1: 77.98,
    x2: 196.448,
    y2: 78.2963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_376_4207",
    x1: 191.805,
    y1: 94.3086,
    x2: 199.053,
    y2: 95.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_376_4207",
    x1: 191.868,
    y1: 84.7734,
    x2: 197.568,
    y2: 85.2044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_376_4207",
    x1: 182.967,
    y1: 70.9302,
    x2: 191.707,
    y2: 71.3518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_376_4207",
    x1: 131.673,
    y1: 94.1509,
    x2: 186.786,
    y2: 101.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_376_4207",
    x1: 160.611,
    y1: 94.3569,
    x2: 189.883,
    y2: 96.4695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_376_4207",
    x1: 187.57,
    y1: 94.3535,
    x2: 196.061,
    y2: 94.5888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_376_4207",
    x1: 191.813,
    y1: 94.3569,
    x2: 198.929,
    y2: 94.7152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_376_4207",
    x1: 191.799,
    y1: 94.356,
    x2: 199.242,
    y2: 95.0904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_376_4207",
    x1: 117.547,
    y1: 94.332,
    x2: 189.537,
    y2: 107.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_376_4207",
    x1: 111.127,
    y1: 94.335,
    x2: 183.611,
    y2: 111.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_376_4207",
    x1: 110.698,
    y1: 90.9087,
    x2: 175.485,
    y2: 117.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_376_4207",
    x1: 117.034,
    y1: 69.9468,
    x2: 179.492,
    y2: 91.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_376_4207",
    x1: 139.534,
    y1: 61.5991,
    x2: 186.682,
    y2: 70.7271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_376_4207",
    x1: 171.599,
    y1: 64.605,
    x2: 190.739,
    y2: 66.2085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0817791,
    stopColor: "#27E6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130FCC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpower);
export default __webpack_public_path__ + "static/media/empower.8dda41bdb524e4bead715df1dcf42509.svg";
export { ForwardRef as ReactComponent };